import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import config from '../config';
import usePermissions from './usePermissions';
import { useNavigate } from 'react-router-dom';
import {
  RefreshCw, User, DollarSign, Check, X, Search, Trash2, Eye, Plus, Edit,
  Save, Download, Printer, Activity, AlertCircle, BarChart2,
  ChevronDown, ChevronRight, ChevronLeft, Layers, List, Grid, AlertTriangle,
  Briefcase, CreditCard as BankIcon, Pin, PinOff, Settings, Filter, FileSpreadsheet, FileText,
  Tag, Clipboard, Calendar as CalendarIcon, Shield,
  TrendingUp, TrendingDown // ✅ أضف هذين هنا
} from 'lucide-react';



import { toast } from 'react-hot-toast';
import * as XLSX from 'xlsx';


const BanksManagement = () => {
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();
  const canDo = (permission) => hasPermission('الخزينة - الصلاحيات', permission);
  
  // حالة البيانات الرئيسية
  const [categories, setCategories] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  
  // حالة النماذج
  const [isAccountModalOpen, setIsAccountModalOpen] = useState(false);
  const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [viewingAccount, setViewingAccount] = useState(null);
  
  // حالة المعاملات
  const [accountTransactions, setAccountTransactions] = useState([]);
  const [isTransactionsLoading, setIsTransactionsLoading] = useState(false);
  const [allTransactions, setAllTransactions] = useState([]);
  const [isAllTransactionsLoading, setIsAllTransactionsLoading] = useState(false);
  

  const [transactionsPerPage, setTransactionsPerPage] = useState(35);
  const transactionsPerPageRef = useRef(35);

  const [accountTransactionsPerPage, setAccountTransactionsPerPage] = useState(15);


  // حالات جديدة للترقيم
  const [accountTransactionsPagination, setAccountTransactionsPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalTransactions: 0,
    hasNextPage: false,
    hasPrevPage: false,
    limit: 15
  });
  
  const [allTransactionsPagination, setAllTransactionsPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalTransactions: 0,
    hasNextPage: false,
    hasPrevPage: false,
    limit: 35
  });
  
  const [showAllAccountTransactions, setShowAllAccountTransactions] = useState(false);
  const [showAllGlobalTransactions, setShowAllGlobalTransactions] = useState(false);
  
  // حالة البحث والعرض
  const [search, setSearch] = useState('');
  const [viewMode, setViewMode] = useState('grid'); // 'grid' or 'list'
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalBalance, setTotalBalance] = useState(0);
  
  // حالة الحسابات المميزة
  const [pinnedAccounts, setPinnedAccounts] = useState([]);
  
  // حالة الشاشة الجانبية
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [totalDeposits, setTotalDeposits] = useState(0);
  const [totalWithdrawals, setTotalWithdrawals] = useState(0);

  // إضافة حالات الأمان الجديدة
  const [securityModal, setSecurityModal] = useState({
    open: false,
    type: '',
    action: '',
    data: null,
    step: 1,
    confirmText: '',
    userInput: '',
    countdown: 10
  });
  const [countdownTimer, setCountdownTimer] = useState(null);

  // حالات التصدير والطباعة
const [isExportModalOpen, setIsExportModalOpen] = useState(false);
const [isAccountExportModalOpen, setIsAccountExportModalOpen] = useState(false);
const [isTransactionsExportModalOpen, setIsTransactionsExportModalOpen] = useState(false);
const [exportingAccount, setExportingAccount] = useState(null);

const [exportOptions, setExportOptions] = useState({
  format: 'pdf',
  includeBalance: true,
  includeTransactions: true,
  includeSummary: true,
  dateRange: 'all',
  customStartDate: '',
  customEndDate: '',
  selectedTypes: ['deposit', 'withdrawal', 'adjustment'],
  // إضافة خيار جديد
  dataScope: 'current' // 'current' = البيانات المعروضة, 'all' = جميع البيانات
});

const [accountExportOptions, setAccountExportOptions] = useState({
  format: 'excel', // غير من 'pdf' إلى 'excel'
  includeBalance: true,
  includeTransactions: true,
  includeSummary: true,
  dateRange: 'all',
  customStartDate: '',
  customEndDate: '',
  selectedTypes: ['deposit', 'withdrawal', 'adjustment'],
  dataScope: 'current'
});

const [transactionsExportOptions, setTransactionsExportOptions] = useState({
  format: 'excel', // غير من 'pdf' إلى 'excel'
  includeBalance: true,
  includeSummary: true,
  dateRange: 'all',
  customStartDate: '',
  customEndDate: '',
  selectedTypes: ['deposit', 'withdrawal', 'adjustment'],
  selectedAccounts: [],
  dataScope: 'current'
});

  // حالة مربع حوار التأكيد القديم - سنستبدله
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: '',
    id: null,
    onConfirm: () => {},
    onCancel: () => {}
  });
  
  // قيم نماذج الإدخال
  const [newAccount, setNewAccount] = useState({
    name: '',
    accountNumber: '',
    additionalDetails: '',
    categoryId: null,
    initialBalance: 0,
  });
  
  const [newCategory, setNewCategory] = useState({
    name: '',
    description: ''
  });

  // دوال الأمان والحماية الجديدة
  
  // تشغيل العد التنازلي
  const startCountdown = () => {
    let timeLeft = 10;
    setSecurityModal(prev => ({ ...prev, countdown: timeLeft }));
    
    const timer = setInterval(() => {
      timeLeft -= 1;
      setSecurityModal(prev => ({ ...prev, countdown: timeLeft }));
      
      if (timeLeft <= 0) {
        clearInterval(timer);
      }
    }, 1000);
    
    setCountdownTimer(timer);
  };

  // فتح نافذة الأمان
  const openSecurityModal = (type, action, data = null) => {
    let confirmText = '';
    
    switch (action) {
      case 'deleteAccount':
        confirmText = 'حذف نهائي';
        break;
      case 'deleteCategory':
        confirmText = 'حذف نهائي';
        break;
      case 'deleteTransaction':
        confirmText = 'حذف نهائي';
        break;
      default:
        confirmText = 'تأكيد العملية';
    }
    
    setSecurityModal({
      open: true,
      type,
      action,
      data,
      step: 1,
      confirmText,
      userInput: '',
      countdown: 10
    });
    
    setTimeout(() => {
      startCountdown();
    }, 500);
  };

  // إغلاق نافذة الأمان
  const closeSecurityModal = () => {
    if (countdownTimer) {
      clearInterval(countdownTimer);
      setCountdownTimer(null);
    }
    
    setSecurityModal({
      open: false,
      type: '',
      action: '',
      data: null,
      step: 1,
      confirmText: '',
      userInput: '',
      countdown: 10
    });
  };

  // الانتقال للخطوة التالية
  const nextSecurityStep = () => {
    if (securityModal.step === 1 && securityModal.countdown <= 0) {
      setSecurityModal(prev => ({ ...prev, step: 2 }));
    } else if (securityModal.step === 2 && securityModal.userInput === securityModal.confirmText) {
      executeSecureAction();
    }
  };

  // تنفيذ العملية الآمنة
  const executeSecureAction = async () => {
    const { action, data } = securityModal;
    
    closeSecurityModal();
    
    switch (action) {
      case 'deleteAccount':
        await performDeleteAccount(data.id);
        break;
      case 'deleteCategory':
        await performDeleteCategory(data.id);
        break;
      case 'deleteTransaction':
        await performDeleteTransaction(data.id);
        break;
      default:
        console.log('عملية غير معروفة');
    }
  };

  // التحقق من صحة النص المُدخل
  const isConfirmTextValid = () => {
    return securityModal.userInput === securityModal.confirmText;
  };

  // الدوال المحدثة للحذف الآمن

  // حذف الحساب بأمان
  const performDeleteAccount = async (id) => {
    try {
      setLoading(true);
      
      const response = await axios.delete(`${config.API_BASE_URL}/api/banks/bank-accounts/${id}`);
      
      if (response.data.success) {
        setAccounts(accounts.filter(account => account.id !== id));
        
        if (pinnedAccounts.includes(id)) {
          const newPinnedAccounts = pinnedAccounts.filter(pinId => pinId !== id);
          setPinnedAccounts(newPinnedAccounts);
          localStorage.setItem('pinnedAccounts', JSON.stringify(newPinnedAccounts));
        }
        
        toast.success('تم حذف الحساب بنجاح');
        fetchTotalBalance();
        fetchAllTransactions(1, false);
      }
    } catch (err) {
      console.error('خطأ في حذف الحساب:', err);
      toast.error('حدث خطأ أثناء حذف الحساب. يرجى المحاولة مرة أخرى.');
    } finally {
      setLoading(false);
    }
  };

  // حذف التصنيف بأمان
  const performDeleteCategory = async (id) => {
    try {
      setLoading(true);
      const response = await axios.delete(`${config.API_BASE_URL}/api/banks/account-categories/${id}`);
      
      if (response.data.success) {
        setCategories(categories.filter(category => category.id !== id));
        toast.success('تم حذف التصنيف بنجاح');
        
        if (selectedCategory === id) {
          setSelectedCategory(null);
          fetchAccounts();
        } else {
          fetchAccounts(selectedCategory);
        }
      }
    } catch (err) {
      console.error('خطأ في حذف التصنيف:', err);
      const errorMessage = err.response?.data?.error || 'حدث خطأ أثناء حذف التصنيف. يرجى المحاولة مرة أخرى.';
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  // حذف المعاملة بأمان
  const performDeleteTransaction = async (transactionId) => {
    // جلب معلومات المعاملة أولاً لتحديد نوعها
    const transaction = accountTransactions.find(t => t.id === transactionId);
    
    try {
      setIsTransactionsLoading(true);
      
      let response;
      
      // اختيار نوع الحذف حسب نوع المعاملة
      if (transaction?.RelatedEntityType === 'employee_transaction') {
        // حذف معاملة موظف
        response = await axios.delete(`${config.API_BASE_URL}/api/banks/bank-accounts/transactions/${transactionId}/sync-employee-delete`);
      } else if (transaction?.RelatedEntityType === 'company_transaction') {
        // حذف معاملة شركة
        response = await axios.delete(`${config.API_BASE_URL}/api/banks/bank-accounts/transactions/${transactionId}/sync-company-delete`);
      } else if (['delegate_commission', 'delegate_financial_operation', 'delegate_debt'].includes(transaction?.RelatedEntityType)) {
        // حذف معاملة مندوب / سلفة / رد سلفة / مديونية مرتبطة بالخزينة
        response = await axios.delete(`${config.API_BASE_URL}/api/banks/bank-accounts/transactions/${transactionId}/sync-delete`);
      } else {
        // الحذف المتزامن الشامل للأنواع الأخرى أو غير المعروفة
        response = await axios.delete(`${config.API_BASE_URL}/api/banks/bank-accounts/transactions/${transactionId}/sync-universal-delete`);
      }
      
      if (response.data.success) {
        toast.success(response.data.message || "تم حذف المعاملة بنجاح مع المزامنة الكاملة");
        
        // تحديث البيانات
        if (viewingAccount) {
          await fetchAccountTransactions(viewingAccount.id);
        }
        
        await fetchTotalBalance();
        await fetchAllTransactions(1, false);
      }
    } catch (error) {
      console.error("خطأ في حذف المعاملة:", error);
      
      if (error.response?.data?.error) {
        toast.error(`خطأ في حذف المعاملة: ${error.response.data.error}`);
      } else {
        toast.error("حدث خطأ أثناء حذف المعاملة");
      }
    } finally {
      setIsTransactionsLoading(false);
    }
  };

  // تحديث دالة حذف الحساب لتستخدم النظام الآمن
  const deleteAccount = (id) => {
    const account = accounts.find(a => a.id === id);
    
    openSecurityModal('danger', 'deleteAccount', {
      id: id,
      name: account?.name,
      amount: formatBalance(account?.balance)
    });
  };



  const getTransactionClientName = (transaction) =>
    transaction?.clientName || transaction?.ClientName ||
    transaction?.originalTransaction?.clientName || transaction?.originalTransaction?.ClientName || '';


  // دالة الطباعة السريعة للمعاملات العامة
const printCurrentTransactions = () => {
  const printWindow = window.open('', '_blank');
  const currentDate = new Date();
  
  const htmlContent = `
    <!DOCTYPE html>
    <html dir="rtl" lang="ar">
    <head>
      <meta charset="UTF-8">
      <title>سجل المعاملات - طباعة سريعة</title>
      <style>
        @page {
          size: A4;
          margin: 15mm;
        }
        
        * { 
          margin: 0; 
          padding: 0; 
          box-sizing: border-box; 
        }
        
        body { 
          font-family: 'Arial', 'Tahoma', sans-serif;
          direction: rtl;
          background: white;
          color: black;
          font-size: 12px;
          line-height: 1.4;
        }
        
        .print-header {
          text-align: center;
          margin-bottom: 20px;
          border-bottom: 3px solid black;
          padding-bottom: 10px;
        }
        
        .print-title {
          font-size: 24px;
          font-weight: bold;
          color: black;
          margin-bottom: 5px;
        }
        
        .print-subtitle {
          font-size: 16px;
          color: black;
          margin-bottom: 5px;
        }
        
        .print-date {
          font-size: 12px;
          color: #333;
        }
        
        .transactions-table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 15px;
          border: 2px solid black;
        }
        
        .transactions-table th,
        .transactions-table td {
          border: 1px solid black;
          padding: 8px 6px;
          text-align: center;
          font-size: 11px;
          color: black;
        }
        
        .transactions-table th {
          background: #f0f0f0;
          font-weight: bold;
          color: black;
          font-size: 12px;
        }
        
        .transactions-table tr:nth-child(even) {
          background: #f8f8f8;
        }
        
        .transactions-table tr:nth-child(odd) {
          background: white;
        }
        
        .amount-positive { 
          color: #000; 
          font-weight: bold;
        }
        
        .amount-negative { 
          color: #000; 
          font-weight: bold;
        }
        
        .transaction-type-deposit {
          background: #e8e8e8;
          color: black;
          padding: 2px 4px;
          border-radius: 3px;
          font-weight: bold;
        }
        
        .transaction-type-withdrawal {
          background: #d0d0d0;
          color: black;
          padding: 2px 4px;
          border-radius: 3px;
          font-weight: bold;
        }
        
        .footer {
          margin-top: 20px;
          text-align: center;
          font-size: 10px;
          color: #666;
          border-top: 1px solid black;
          padding-top: 10px;
        }
        
        .summary-info {
          background: #f5f5f5;
          border: 1px solid black;
          padding: 10px;
          margin-bottom: 15px;
          text-align: center;
        }
        
        @media print {
          body { 
            font-size: 10px;
          }
          
          .print-title {
            font-size: 20px;
          }
          
          .print-subtitle {
            font-size: 14px;
          }
          
          .transactions-table th,
          .transactions-table td { 
            padding: 4px 3px; 
            font-size: 9px;
          }
          
          .transactions-table th {
            font-size: 10px;
          }
        }
      </style>
    </head>
    <body>
      <div class="print-header">
        <div class="print-title">سجل المعاملات</div>
        <div class="print-subtitle">طباعة سريعة للمعاملات المعروضة</div>
        <div class="print-date">
          تاريخ الطباعة: ${currentDate.toLocaleDateString('ar-EG')} - ${currentDate.toLocaleTimeString('ar-EG')}
        </div>
      </div>

      <div class="summary-info">
        <strong>عدد المعاملات المعروضة: ${allTransactions.length}</strong> |
        <strong>من إجمالي: ${allTransactionsPagination.totalTransactions}</strong> |
        <strong>الصفحة: ${allTransactionsPagination.currentPage} من ${allTransactionsPagination.totalPages}</strong>
      </div>

      <table class="transactions-table">
        <thead>
          <tr>
            <th style="width: 8%;">#</th>
            <th style="width: 15%;">التاريخ</th>
            <th style="width: 20%;">اسم الحساب</th>
            <th style="width: 12%;">النوع</th>
            <th style="width: 15%;">المبلغ</th>
            <th style="width: 15%;">الرصيد</th>
            <th style="width: 15%;">التفاصيل</th>
          </tr>
        </thead>
        <tbody>
          ${allTransactions.length === 0 ? `
            <tr>
              <td colspan="7" style="text-align: center; padding: 20px; color: #666;">
                لا توجد معاملات للعرض
              </td>
            </tr>
          ` : allTransactions.map((transaction, index) => `
            <tr>
              <td>${index + 1}</td>
              <td style="font-size: 9px;">${formatDate(transaction.date).split(' - ')[0]}</td>
              <td style="font-weight: bold;">${transaction.accountName || 'غير محدد'}</td>
              <td>
                <span class="${
                  transaction.type.toLowerCase() === 'deposit' || transaction.type.toLowerCase() === 'إيداع' 
                    ? 'transaction-type-deposit' 
                    : 'transaction-type-withdrawal'
                }">
                  ${
                    transaction.type.toLowerCase() === 'deposit' || transaction.type.toLowerCase() === 'إيداع' ? 'إيداع' : 
                    transaction.type.toLowerCase() === 'adjustment' ? 'تعديل' : 'سحب'
                  }
                </span>
              </td>
              <td class="${
                transaction.type.toLowerCase() === 'deposit' || transaction.type.toLowerCase() === 'إيداع' 
                  ? 'amount-positive' 
                  : 'amount-negative'
              }">${formatBalance(transaction.amount)}</td>
              <td class="amount-positive">${formatBalance(transaction.balance)}</td>
              <td style="text-align: right; font-size: 9px; max-width: 150px; overflow: hidden;">
                ${getTransactionClientName(transaction) ? `<strong>العميل: ${getTransactionClientName(transaction)}</strong><br>` : ''}
                ${transaction.companyDetails ? `
                  <strong>${transaction.companyDetails.categoryName}:</strong> 
                  ${(transaction.companyDetails.description || transaction.companyDetails.notes || '').substring(0, 40)}${
                    (transaction.companyDetails.description || transaction.companyDetails.notes || '').length > 40 ? '...' : ''
                  }
                ` : (transaction.notes || '-').substring(0, 40)}
              </td>
            </tr>
          `).join('')}
        </tbody>
      </table>

      <div class="footer">
        طُبع من نظام إدارة الخزينة والمحافظ | ${currentDate.toLocaleString('ar-EG')}
      </div>
    </body>
    </html>
  `;
  
  printWindow.document.write(htmlContent);
  printWindow.document.close();
  
  printWindow.onload = () => {
    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    }, 500);
  };
};

// دالة الطباعة السريعة لمعاملات الحساب المفرد
const printAccountTransactions = () => {
  if (!viewingAccount) return;
  
  const printWindow = window.open('', '_blank');
  const currentDate = new Date();
  
  const htmlContent = `
    <!DOCTYPE html>
    <html dir="rtl" lang="ar">
    <head>
      <meta charset="UTF-8">
      <title>معاملات ${viewingAccount.name} - طباعة سريعة</title>
      <style>
        @page {
          size: A4;
          margin: 15mm;
        }
        
        * { 
          margin: 0; 
          padding: 0; 
          box-sizing: border-box; 
        }
        
        body { 
          font-family: 'Arial', 'Tahoma', sans-serif;
          direction: rtl;
          background: white;
          color: black;
          font-size: 12px;
          line-height: 1.4;
        }
        
        .print-header {
          text-align: center;
          margin-bottom: 20px;
          border-bottom: 3px solid black;
          padding-bottom: 15px;
        }
        
        .print-title {
          font-size: 24px;
          font-weight: bold;
          color: black;
          margin-bottom: 5px;
        }
        
        .print-subtitle {
          font-size: 18px;
          color: black;
          margin-bottom: 8px;
        }
        
        .print-date {
          font-size: 12px;
          color: #333;
        }
        
        .account-info {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          gap: 15px;
          margin-bottom: 20px;
          border: 2px solid black;
          padding: 15px;
          background: #f9f9f9;
        }
        
        .info-item {
          text-align: center;
        }
        
        .info-label {
          font-weight: bold;
          font-size: 11px;
          margin-bottom: 3px;
          color: #333;
        }
        
        .info-value {
          font-size: 14px;
          font-weight: bold;
          color: black;
        }
        
        .transactions-table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 15px;
          border: 2px solid black;
        }
        
        .transactions-table th,
        .transactions-table td {
          border: 1px solid black;
          padding: 8px 6px;
          text-align: center;
          font-size: 11px;
          color: black;
        }
        
        .transactions-table th {
          background: #f0f0f0;
          font-weight: bold;
          color: black;
          font-size: 12px;
        }
        
        .transactions-table tr:nth-child(even) {
          background: #f8f8f8;
        }
        
        .transactions-table tr:nth-child(odd) {
          background: white;
        }
        
        .amount-positive { 
          color: #000; 
          font-weight: bold;
        }
        
        .amount-negative { 
          color: #000; 
          font-weight: bold;
        }
        
        .transaction-type-deposit {
          background: #e8e8e8;
          color: black;
          padding: 2px 4px;
          border-radius: 3px;
          font-weight: bold;
        }
        
        .transaction-type-withdrawal {
          background: #d0d0d0;
          color: black;
          padding: 2px 4px;
          border-radius: 3px;
          font-weight: bold;
        }
        
        .footer {
          margin-top: 20px;
          text-align: center;
          font-size: 10px;
          color: #666;
          border-top: 1px solid black;
          padding-top: 10px;
        }
        
        @media print {
          body { 
            font-size: 10px;
          }
          
          .print-title {
            font-size: 20px;
          }
          
          .print-subtitle {
            font-size: 16px;
          }
          
          .transactions-table th,
          .transactions-table td { 
            padding: 4px 3px; 
            font-size: 9px;
          }
          
          .transactions-table th {
            font-size: 10px;
          }
        }
      </style>
    </head>
    <body>
      <div class="print-header">
        <div class="print-title">سجل معاملات الحساب</div>
        <div class="print-subtitle">${viewingAccount.name}</div>
        <div class="print-date">
          تاريخ الطباعة: ${currentDate.toLocaleDateString('ar-EG')} - ${currentDate.toLocaleTimeString('ar-EG')}
        </div>
      </div>

      <div class="account-info">
        <div class="info-item">
          <div class="info-label">رقم الحساب</div>
          <div class="info-value">${viewingAccount.accountNumber}</div>
        </div>
        <div class="info-item">
          <div class="info-label">الرصيد الحالي</div>
          <div class="info-value">${formatBalance(viewingAccount.balance)}</div>
        </div>
        <div class="info-item">
          <div class="info-label">عدد المعاملات</div>
          <div class="info-value">${accountTransactions.length}</div>
        </div>
      </div>

      <table class="transactions-table">
        <thead>
          <tr>
            <th style="width: 8%;">#</th>
            <th style="width: 18%;">التاريخ والوقت</th>
            <th style="width: 12%;">النوع</th>
            <th style="width: 15%;">المبلغ</th>
            <th style="width: 15%;">الرصيد</th>
            <th style="width: 32%;">التفاصيل</th>
          </tr>
        </thead>
        <tbody>
          ${accountTransactions.length === 0 ? `
            <tr>
              <td colspan="6" style="text-align: center; padding: 20px; color: #666;">
                لا توجد معاملات للعرض
              </td>
            </tr>
          ` : accountTransactions.map((transaction, index) => `
            <tr>
              <td>${index + 1}</td>
              <td style="font-size: 9px;">${formatDate(transaction.date)}</td>
              <td>
                <span class="${
                  transaction.type.toLowerCase() === 'deposit' || transaction.type.toLowerCase() === 'إيداع' 
                    ? 'transaction-type-deposit' 
                    : 'transaction-type-withdrawal'
                }">
                  ${
                    transaction.type.toLowerCase() === 'deposit' || transaction.type.toLowerCase() === 'إيداع' ? 'إيداع' : 
                    transaction.type.toLowerCase() === 'adjustment' ? 'تعديل' : 'سحب'
                  }
                </span>
              </td>
              <td class="${
                transaction.type.toLowerCase() === 'deposit' || transaction.type.toLowerCase() === 'إيداع' 
                  ? 'amount-positive' 
                  : 'amount-negative'
              }">${formatBalance(transaction.amount)}</td>
              <td class="amount-positive">${formatBalance(transaction.balance)}</td>
              <td style="text-align: right; font-size: 9px;">
                ${getTransactionClientName(transaction) ? `<strong>العميل: ${getTransactionClientName(transaction)}</strong><br>` : ''}
                ${transaction.companyDetails ? `
                  <strong>${transaction.companyDetails.categoryName}:</strong><br>
                  ${transaction.companyDetails.description || transaction.companyDetails.notes || ''}
                ` : transaction.notes || '-'}
              </td>
            </tr>
          `).join('')}
        </tbody>
      </table>

      <div class="footer">
        طُبع من نظام إدارة الخزينة والمحافظ | ${currentDate.toLocaleString('ar-EG')}
      </div>
    </body>
    </html>
  `;
  
  printWindow.document.write(htmlContent);
  printWindow.document.close();
  
  printWindow.onload = () => {
    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    }, 500);
  };
};


  // تحديث دالة حذف التصنيف لتستخدم النظام الآمن
  const deleteCategory = (id) => {
    const category = categories.find(c => c.id === id);
    
    openSecurityModal('warning', 'deleteCategory', {
      id: id,
      name: category?.name
    });
  };

  // تحديث دالة حذف المعاملة لتستخدم النظام الآمن
  const deleteTransaction = async (transactionId) => {
    const transaction = accountTransactions.find(t => t.id === transactionId);
    
    openSecurityModal('warning', 'deleteTransaction', {
      id: transactionId,
      amount: formatBalance(transaction?.amount),
      type: transaction?.type
    });
  };

  // باقي الكود يبقى كما هو...
  // إضافة دالة التشخيص هنا
  const debugTransactionData = async (accountId, transactionId) => {
    try {
      console.log(`بدء تشخيص بيانات المعاملة: ${transactionId} للحساب: ${accountId}`);
      
      const response = await axios.get(`${config.API_BASE_URL}/api/banks/bank-accounts/transactions/${transactionId}/details`);
      
      if (response.data) {
        console.log("بيانات المعاملة المسترجعة:", response.data);
      } else {
        console.error("لم يتم العثور على بيانات للمعاملة");
      }
    } catch (error) {
      console.error("خطأ في تشخيص بيانات المعاملة:", error);
    }
  };



  useEffect(() => {
  // جلب الحسابات المثبتة من localStorage
  const savedPinnedAccounts = localStorage.getItem('pinnedAccounts');
  if (savedPinnedAccounts) {
    try {
      const parsedPinnedAccounts = JSON.parse(savedPinnedAccounts);
      setPinnedAccounts(parsedPinnedAccounts);
    } catch (error) {
      console.error('خطأ في قراءة الحسابات المثبتة من التخزين المحلي:', error);
      setPinnedAccounts([]);
    }
  }
}, []); // يتم تنفيذه مرة واحدة عند تحميل المكون

useEffect(() => {
  fetchData();
  
  const intervalId = setInterval(() => {
    console.log('جاري تحديث البيانات من الخادم...');
    fetchData();
  }, 5 * 60 * 1000);
  
  return () => clearInterval(intervalId);
}, []); // تحميل أولي وتحديث دوري فقط - تغيير عدد الصفوف يتم من المعالج مباشرة بدون طلب مزدوج

useEffect(() => {
  transactionsPerPageRef.current = transactionsPerPage;
}, [transactionsPerPage]);

  // useEffect الجديد للمزامنة 
  useEffect(() => {
    const syncPaymentRequirements = async () => {
      try {
        const syncResponse = await fetch(`${config.API_BASE_URL}/api/sync/payment-requirements`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          }
        });

        const contentType = syncResponse.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
          console.error('الاستجابة ليست JSON:', await syncResponse.text());
          return;
        }

        const syncData = await syncResponse.json();

        if (syncData.success) {
          console.log('تمت المزامنة بنجاح');
        }
      } catch (error) {
        console.error('خطأ في مزامنة المبلغ المطلوب:', error);
      }
    };

    const syncInterval = setInterval(syncPaymentRequirements, 5 * 60 * 1000);
    return () => clearInterval(syncInterval);
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      
      await Promise.all([
        fetchCategories(),
        fetchAccounts(),
        fetchTotalBalance()
      ]);
      
      // جلب أول صفحة من المعاملات فقط
      setShowAllGlobalTransactions(false); // إعادة تعيين حالة العرض
      await fetchAllTransactions(1, false, transactionsPerPageRef.current || transactionsPerPage);
      
      setLoading(false);
    } catch (err) {
      console.error('خطأ في جلب البيانات:', err);
      setError('حدث خطأ أثناء جلب البيانات. يرجى التحقق من اتصالك بالإنترنت والمحاولة مرة أخرى.');
      setLoading(false);
    }
  };

  // دالة لجلب التصنيفات
  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${config.API_BASE_URL}/api/banks/account-categories`);
      setCategories(response.data);
      return response.data;
    } catch (err) {
      console.error('خطأ في جلب التصنيفات:', err);
      throw err;
    }
  };

  // دالة لجلب الحسابات
  const fetchAccounts = async (categoryId = null) => {
    try {
      const url = categoryId ? 
        `${config.API_BASE_URL}/api/banks/bank-accounts?categoryId=${categoryId}` : 
        `${config.API_BASE_URL}/api/banks/bank-accounts`;
      const response = await axios.get(url);
      
      const accountsWithNumbers = response.data.map(account => ({
        ...account,
        balance: parseFloat(account.balance || 0)
      }));
      
      setAccounts(accountsWithNumbers);
      return accountsWithNumbers;
    } catch (err) {
      console.error('خطأ في جلب الحسابات:', err);
      throw err;
    }
  };

  // جلب إجمالي الرصيد
  const fetchTotalBalance = async () => {
    try {
      const response = await axios.get(`${config.API_BASE_URL}/api/banks/total-balance`);
      if (response.data && response.data.grandTotal !== undefined) {
        setTotalBalance(response.data.grandTotal);
      }
      return response.data;
    } catch (err) {
      console.error('خطأ في جلب إجمالي الرصيد:', err);
      throw err;
    }
  };

const fetchAccountTransactions = async (accountId, page = 1, loadAll = false, customLimit = null) => {
  try {
    setIsTransactionsLoading(true);
    
    const limit = customLimit || accountTransactionsPerPage;
    const url = `${config.API_BASE_URL}/api/banks/bank-accounts/${accountId}/transactions-with-company?page=${page}&limit=${limit}&loadAll=${loadAll}`;
    const response = await axios.get(url);
    
    let transactions = [];
    let deposits = 0;
    let withdrawals = 0;
    let pagination = {};
    
    if (response.data && response.data.transactions) {
      transactions = response.data.transactions;
      deposits = response.data.summary.totalDeposits;
      withdrawals = response.data.summary.totalWithdrawals;
      pagination = response.data.pagination;
    }
    
    const formattedTransactions = transactions.map(transaction => ({
      ...transaction,
      RelatedBankTransactionID: transaction.relatedEntityID, 
      RelatedEntityType: transaction.relatedEntityType,
      paymentMethodId: transaction.paymentMethodID || transaction.PaymentMethodID,
      paymentMethodType: transaction.paymentMethodType || transaction.PaymentMethodType,
      bankTransactionId: transaction.id,
      originalTransaction: transaction
    }));

    // إذا كان هذا تحميل صفحة جديدة وليس الصفحة الأولى، أضف للمعاملات الموجودة
    if (page > 1 && !loadAll) {
      setAccountTransactions(prev => [...prev, ...formattedTransactions]);
    } else {
      setAccountTransactions(formattedTransactions);
    }

    setTotalDeposits(deposits);
    setTotalWithdrawals(withdrawals);
    setAccountTransactionsPagination(pagination);
    
    return formattedTransactions;
  } catch (err) {
    console.error('⌐ خطأ في جلب معاملات الحساب:', err);
    toast.error('حدث خطأ أثناء جلب معاملات الحساب');
    
    if (page === 1) {
      setAccountTransactions([]);
      setTotalDeposits(0);
      setTotalWithdrawals(0);
    }
  } finally {
    setIsTransactionsLoading(false);
  }
};

const handleAccountTransactionsPerPageChange = (newLimit) => {
  setAccountTransactionsPerPage(newLimit);
  setShowAllAccountTransactions(false);
  if (viewingAccount) {
    fetchAccountTransactions(viewingAccount.id, 1, false, newLimit);
  }
};


  // دالة لتحميل المزيد من معاملات الحساب
  const loadMoreAccountTransactions = () => {
    if (accountTransactionsPagination.hasNextPage && !isTransactionsLoading) {
      fetchAccountTransactions(
        viewingAccount.id, 
        accountTransactionsPagination.currentPage + 1, 
        false
      );
    }
  };

  const fetchAllTransactions = async (page = 1, loadAll = false, customLimit = null) => {
    try {
      setIsAllTransactionsLoading(true);
      
      const limit = customLimit || transactionsPerPage; // استخدام العدد المحدد
      const url = `${config.API_BASE_URL}/api/banks/all-transactions?page=${page}&limit=${limit}&loadAll=${loadAll}`;
      const response = await axios.get(url);
      
      if (response.data && response.data.transactions) {
        const transactions = response.data.transactions;
        const pagination = response.data.pagination;
  
        // إذا كان loadAll = true، أضف للمعاملات الموجودة
        // إذا كان loadAll = false، استبدل المعاملات بالصفحة الجديدة
        if (loadAll && page > 1) {
          setAllTransactions(prev => [...prev, ...transactions]);
        } else {
          // عرض بيانات الصفحة الحالية فقط
          setAllTransactions(transactions);
        }
  
        setAllTransactionsPagination(pagination);
      } else {
        if (!loadAll || page === 1) {
          setAllTransactions([]);
        }
      }
    } catch (err) {
      console.error('خطأ في جلب جميع المعاملات:', err);
      toast.error('حدث خطأ أثناء جلب المعاملات');
      if (!loadAll || page === 1) {
        setAllTransactions([]);
      }
    } finally {
      setIsAllTransactionsLoading(false);
    }
  };


  const handleTransactionsPerPageChange = (newLimit) => {
    const parsedLimit = Number(newLimit);
    if (!Number.isFinite(parsedLimit) || parsedLimit <= 0) return;

    transactionsPerPageRef.current = parsedLimit;
    setTransactionsPerPage(parsedLimit);
    setShowAllGlobalTransactions(false); // إعادة تعيين حالة العرض
    fetchAllTransactions(1, false, parsedLimit); // جلب الصفحة الأولى بالحد الجديد بدون تشغيل fetchData مرة ثانية
  };

  // دالة لتحميل المزيد من جميع المعاملات
// دالة لتحميل المزيد من جميع المعاملات
const loadMoreAllTransactions = () => {
  if (allTransactionsPagination.hasNextPage && !isAllTransactionsLoading) {
    fetchAllTransactions(allTransactionsPagination.currentPage + 1, true); // loadAll = true هنا فقط
  }
};

  // دالة لعرض جميع معاملات الحساب
  const showAllAccountTransactionsHandler = () => {
    setShowAllAccountTransactions(true);
    fetchAccountTransactions(viewingAccount.id, 1, true);
  };

  // دالة لعرض جميع المعاملات العامة
  const showAllGlobalTransactionsHandler = () => {
    setShowAllGlobalTransactions(true);
    fetchAllTransactions(1, true);
  };

  // دالة لتغيير التصنيف المحدد
  const handleCategoryChange = (categoryId) => {
    setSelectedCategory(categoryId === "all" ? null : parseInt(categoryId));
    fetchAccounts(categoryId === "all" ? null : categoryId);
  };

  // إضافة تصنيف جديد
  const addCategory = async () => {
    if (!newCategory.name) {
      toast.error('يرجى إدخال اسم التصنيف');
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(`${config.API_BASE_URL}/api/banks/account-categories`, newCategory);
      
      if (response.data.success) {
        setCategories([...categories, response.data.category]);
        resetCategoryForm();
        toast.success('تم إضافة التصنيف بنجاح');
        fetchAccounts(selectedCategory);
      }
    } catch (err) {
      console.error('خطأ في إضافة التصنيف:', err);
      toast.error('حدث خطأ أثناء إضافة التصنيف. يرجى المحاولة مرة أخرى.');
    } finally {
      setLoading(false);
    }
  };

  // تعديل تصنيف
  const editCategory = async () => {
    if (!newCategory.name) {
      toast.error('يرجى إدخال اسم التصنيف');
      return;
    }

    try {
      setLoading(true);
      const response = await axios.put(`${config.API_BASE_URL}/api/banks/account-categories/${editingCategory.id}`, newCategory);
      
      if (response.data.success) {
        setCategories(categories.map(category => 
          category.id === editingCategory.id 
            ? { ...newCategory, id: category.id, createdAt: category.createdAt } 
            : category
        ));
        resetCategoryForm();
        toast.success('تم تحديث التصنيف بنجاح');
        fetchAccounts(selectedCategory);
      }
    } catch (err) {
      console.error('خطأ في تعديل التصنيف:', err);
      toast.error('حدث خطأ أثناء تعديل التصنيف. يرجى المحاولة مرة أخرى.');
    } finally {
      setLoading(false);
    }
  };

  // إعادة تعيين نموذج التصنيف
  const resetCategoryForm = () => {
    setNewCategory({
      name: '',
      description: ''
    });
    setIsCategoryModalOpen(false);
    setEditingCategory(null);
  };

  // بدء تعديل تصنيف
  const startEditCategory = (category) => {
    setEditingCategory(category);
    setNewCategory({
      name: category.name,
      description: category.description || ''
    });
    setIsCategoryModalOpen(true);
  };

  // إضافة حساب جديد
  const addAccount = async () => {
    if (!newAccount.name || !newAccount.accountNumber) {
      toast.error('يرجى إدخال اسم الحساب ورقم الحساب');
      return;
    }

    try {
      setLoading(true);
      const accountData = {
        ...newAccount,
        initialBalance: parseFloat(newAccount.initialBalance || 0),
        categoryId: newAccount.categoryId || selectedCategory
      };
      
      const response = await axios.post(`${config.API_BASE_URL}/api/banks/bank-accounts`, accountData);
      
      if (response.data.success) {
        // إضافة معاملة للرصيد الافتتاحي
        if (parseFloat(newAccount.initialBalance) > 0) {
          try {
            await axios.post(`${config.API_BASE_URL}/api/banks/bank-accounts/${response.data.account.id}/transactions`, {
              type: 'deposit',
              amount: newAccount.initialBalance,
              notes: 'الرصيد الافتتاحي'
            });
          } catch (err) {
            console.error('خطأ في إضافة الرصيد الافتتاحي:', err);
          }
        }

        if (selectedCategory === null || selectedCategory === accountData.categoryId) {
          setAccounts([...accounts, {...response.data.account, balance: accountData.initialBalance}]);
        }
        resetAccountForm();
        toast.success('تم إضافة الحساب بنجاح');
        
        fetchTotalBalance();
        fetchAllTransactions(1, false);
      }
    } catch (err) {
      console.error('خطأ في إضافة الحساب:', err);
      toast.error('حدث خطأ أثناء إضافة الحساب. يرجى المحاولة مرة أخرى.');
    } finally {
      setLoading(false);
    }
  };

  // إعادة تعيين نموذج الحساب
  const resetAccountForm = () => {
    setNewAccount({
      name: '',
      accountNumber: '',
      additionalDetails: '',
      categoryId: null,
      initialBalance: 0
    });
    setIsAccountModalOpen(false);
  };

  const viewAccountDetails = async (account) => {
    setViewingAccount(account);
    setShowAllAccountTransactions(false); // إعادة تعيين حالة العرض
    await fetchAccountTransactions(account.id, 1, false); // جلب الصفحة الأولى فقط
  };

  // إغلاق نافذة تفاصيل الحساب
  const closeAccountDetails = () => {
    setViewingAccount(null);
    setAccountTransactions([]);
  };


  // تابع الكود...

 // تبديل حالة تمييز الحساب
 const togglePinAccount = (accountId) => {
  let newPinnedAccounts;
  
  if (pinnedAccounts.includes(accountId)) {
    // إزالة الحساب من قائمة الحسابات المميزة
    newPinnedAccounts = pinnedAccounts.filter(id => id !== accountId);
    toast.success('تم إلغاء تمييز الحساب');
  } else {
    // إضافة الحساب إلى قائمة الحسابات المميزة
    newPinnedAccounts = [...pinnedAccounts, accountId];
    toast.success('تم تمييز الحساب');
  }
  
  // تحديث الحالة وحفظها في التخزين المحلي
  setPinnedAccounts(newPinnedAccounts);
  localStorage.setItem('pinnedAccounts', JSON.stringify(newPinnedAccounts));
};

// دالة مساعدة للحصول على اسم التصنيف
const getCategoryName = (categoryId) => {
  if (!categoryId) return 'بدون تصنيف';
  const category = categories.find(cat => cat.id === categoryId);
  return category ? category.name : 'تصنيف غير معروف';
};

// فلترة الحسابات حسب البحث والتصنيف
const getFilteredAccounts = () => {
  let filtered = [...accounts];
  
  // فلترة حسب التصنيف
  if (selectedCategory !== null) {
    filtered = filtered.filter(account => account.categoryId === selectedCategory);
  }
  
  // فلترة حسب البحث
  if (search.trim()) {
    const searchLower = search.toLowerCase();
    filtered = filtered.filter(account => 
      (account.name && account.name.toLowerCase().includes(searchLower)) ||
      (account.accountNumber && account.accountNumber.toLowerCase().includes(searchLower)) ||
      (account.additionalDetails && account.additionalDetails.toLowerCase().includes(searchLower))
    );
  }
  
  return filtered;
};

// الحصول على الحسابات المميزة
const getPinnedAccounts = () => {
  return accounts.filter(account => pinnedAccounts.includes(account.id));
};

// فلترة وترتيب الحسابات
const filteredAccounts = getFilteredAccounts();
const pinnedAccountsList = getPinnedAccounts();

// تنسيق الرصيد لعرضه
const formatBalance = (balance) => {
  // تأكد من أن القيمة رقمية
  const numericBalance = parseFloat(balance || 0);
  
  // عرض الرقم بدون أي فواصل أو كسور عشرية
  return Math.round(numericBalance) + ' ج.م';
};

// تنسيق التاريخ لعرضه
const formatDate = (dateString) => {
  if (!dateString) return '-';
  
  const date = new Date(dateString);
  
  // تنسيق التاريخ بالميلادي بالصيغة العربية (يوم/شهر/سنة)
  const formattedDate = date.toLocaleDateString('ar-EG', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    calendar: 'gregory' // استخدام التقويم الميلادي بشكل صريح
  });
  
  // تنسيق الوقت
  const formattedTime = date.toLocaleTimeString('ar-EG', { 
    hour: '2-digit', 
    minute: '2-digit',
    hour12: true // استخدام نظام 12 ساعة (صباحًا/مساءً)
  });
  
  return `${formattedDate} - ${formattedTime}`;
};

// دالة مزامنة المعاملات مع نظام العملاء
const syncTransactionWithClientSystem = async (transaction) => {
  try {
    const response = await axios.post(`${config.CLIENTS_API_URL}/api/sync/transaction`, {
      TransactionID: null, // سيتم تعيينه من نظام العملاء إذا كان مرتبطًا
      Amount: transaction.amount,
      Notes: transaction.notes,
      TransactionType: transaction.type === 'إيداع' ? 'إيداع' : 'سحب',
      TransactionDate: transaction.date
    });

    console.log('نتيجة مزامنة المعاملة مع نظام العملاء:', response.data);
    return response.data.success;
  } catch (error) {
    console.error('خطأ في مزامنة المعاملة مع نظام العملاء:', error);
    return false;
  }
};




// دالة تنسيق التاريخ للتصدير
const formatDateForReport = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('ar-EG', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    weekday: 'long'
  });
};

// دالة تنسيق المبلغ للتقارير
const formatAmountForReport = (amount) => {
  return new Intl.NumberFormat('ar-EG', {
    style: 'currency',
    currency: 'EGP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

// دالة التصدير العام لجميع المحافظ - PDF
const exportAllAccountsPDF = () => {
  const printWindow = window.open('', '_blank');
  const currentDate = new Date();
  
  const htmlContent = `
    <!DOCTYPE html>
    <html dir="rtl" lang="ar">
    <head>
      <meta charset="UTF-8">
      <title>تقرير الخزينة والمحافظ</title>
      <style>
        @page {
          size: A4;
          margin: 15mm;
          @bottom-center {
            content: "صفحة " counter(page) " من " counter(pages);
          }
        }
        
        * { 
          margin: 0; 
          padding: 0; 
          box-sizing: border-box; 
        }
        
        body { 
          font-family: 'Arial', 'Tahoma', sans-serif;
          direction: rtl;
          background: white;
          color: #000;
          font-size: 12px;
          line-height: 1.4;
        }
        
        .page-container {
          width: 100%;
          margin: 0 auto;
          background: white;
        }
        
        .header {
          text-align: center;
          margin-bottom: 20px;
          border-bottom: 2px solid #000;
          padding-bottom: 10px;
          page-break-inside: avoid;
        }
        
        .company-name {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 5px;
        }
        
        .report-title {
          font-size: 16px;
          margin-bottom: 5px;
        }
        
        .report-date {
          font-size: 12px;
          color: #666;
        }
        
        .summary-box {
          border: 1px solid #000;
          padding: 10px;
          margin-bottom: 15px;
          page-break-inside: avoid;
        }
        
        .summary-title {
          font-size: 14px;
          font-weight: bold;
          text-align: center;
          margin-bottom: 8px;
          border-bottom: 1px solid #ccc;
          padding-bottom: 5px;
        }
        
        .summary-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 3px;
          padding: 2px 5px;
        }
        
        .summary-row:nth-child(even) {
          background: #f5f5f5;
        }
        
        .accounts-section {
          margin-top: 15px;
        }
        
        .section-title {
          font-size: 14px;
          font-weight: bold;
          text-align: center;
          margin-bottom: 10px;
          border-bottom: 1px solid #000;
          padding-bottom: 5px;
        }
        
        .accounts-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 10px;
          margin-bottom: 15px;
        }
        
        .account-card {
          border: 1px solid #000;
          padding: 8px;
          background: white;
          page-break-inside: avoid;
          min-height: 80px;
        }
        
        .account-name {
          font-size: 12px;
          font-weight: bold;
          margin-bottom: 3px;
          border-bottom: 1px dotted #ccc;
          padding-bottom: 2px;
        }
        
        .account-details {
          font-size: 10px;
          margin-bottom: 2px;
          color: #333;
        }
        
        .account-balance {
          font-size: 11px;
          font-weight: bold;
          text-align: center;
          margin-top: 5px;
          padding: 3px;
          border: 1px solid #ccc;
          background: #f9f9f9;
        }
        
        .positive { color: #0D7C0D; }
        .negative { color: #C41E3A; }
        .zero { color: #666; }
        
        .footer {
          position: fixed;
          bottom: 10mm;
          left: 15mm;
          right: 15mm;
          text-align: center;
          font-size: 10px;
          color: #666;
          border-top: 1px solid #ccc;
          padding-top: 5px;
        }
        
        @media print {
          .account-card {
            break-inside: avoid;
          }
          
          .accounts-grid {
            break-inside: auto;
          }
          
          body {
            font-size: 11px;
          }
          
          .company-name {
            font-size: 16px;
          }
          
          .report-title {
            font-size: 14px;
          }
        }
      </style>
    </head>
    <body>
      <div class="page-container">
        <!-- Header -->
        <div class="header">
          <div class="company-name">إدارة الخزينة والمحافظ</div>
          <div class="report-title">تقرير شامل للأرصدة والحسابات</div>
          <div class="report-date">
            تاريخ التقرير: ${formatDateForReport(currentDate)} | 
            عدد الحسابات: ${accounts.length}
          </div>
        </div>

        <!-- Summary -->
        <div class="summary-box">
          <div class="summary-title">ملخص الخزينة</div>
          <div class="summary-row">
            <span>الرصيد الإجمالي:</span>
            <span style="font-weight: bold;">${formatBalance(totalBalance)}</span>
          </div>
          <div class="summary-row">
            <span>عدد الحسابات:</span>
            <span>${accounts.length}</span>
          </div>
          <div class="summary-row">
            <span>عدد التصنيفات:</span>
            <span>${categories.length}</span>
          </div>
          <div class="summary-row">
            <span>الحسابات الموجبة:</span>
            <span class="positive">${accounts.filter(a => parseFloat(a.balance) > 0).length}</span>
          </div>
          <div class="summary-row">
            <span>الحسابات المتوازنة:</span>
            <span class="zero">${accounts.filter(a => parseFloat(a.balance) === 0).length}</span>
          </div>
          <div class="summary-row">
            <span>الحسابات السالبة:</span>
            <span class="negative">${accounts.filter(a => parseFloat(a.balance) < 0).length}</span>
          </div>
        </div>

        <!-- Accounts Section -->
        <div class="accounts-section">
          <div class="section-title">تفاصيل الحسابات</div>
          <div class="accounts-grid">
            ${accounts.map(account => `
              <div class="account-card">
                <div class="account-name">${account.name}</div>
                <div class="account-details">رقم الحساب: ${account.accountNumber}</div>
                <div class="account-details">التصنيف: ${getCategoryName(account.categoryId)}</div>
                ${account.additionalDetails ? `
                  <div class="account-details" style="font-style: italic; margin-top: 3px;">
                    ${account.additionalDetails.length > 50 ? account.additionalDetails.substring(0, 50) + '...' : account.additionalDetails}
                  </div>
                ` : ''}
                <div class="account-balance ${parseFloat(account.balance) > 0 ? 'positive' : parseFloat(account.balance) < 0 ? 'negative' : 'zero'}">
                  ${formatBalance(account.balance)}
                </div>
              </div>
            `).join('')}
          </div>
        </div>

        <!-- Footer -->
        <div class="footer">
          تم إنشاء هذا التقرير بواسطة نظام إدارة الخزينة والمحافظ | 
          ${currentDate.toLocaleString('ar-EG')}
        </div>
      </div>
    </body>
    </html>
  `;
  
  printWindow.document.write(htmlContent);
  printWindow.document.close();
  
  printWindow.onload = () => {
    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    }, 500);
  };
};

// دالة التصدير العام لجميع المحافظ - Excel
const exportAllAccountsExcel = () => {
  try {
    // إعداد البيانات
    const currentDate = new Date();
    const headerData = [
      [`تقرير الخزينة والمحافظ الشامل`],
      [`تاريخ التقرير: ${formatDateForReport(currentDate)}`],
      [`عدد الحسابات: ${accounts.length}`],
      [`الرصيد الإجمالي: ${formatBalance(totalBalance)}`],
      [], // سطر فارغ
      [`الملخص المالي:`],
      [`البيان`, `القيمة`],
      [`عدد الحسابات`, `${accounts.length}`],
      [`الرصيد الإجمالي`, `${formatBalance(totalBalance)}`],
      [`الحسابات الموجبة`, `${accounts.filter(a => parseFloat(a.balance) > 0).length}`],
      [`الحسابات السالبة`, `${accounts.filter(a => parseFloat(a.balance) < 0).length}`],
      [], // سطر فارغ
      [`تفاصيل الحسابات:`],
      [`اسم الحساب`, `رقم الحساب`, `التصنيف`, `الرصيد (جنيه)`, `التفاصيل الإضافية`]
    ];
    
    // إضافة بيانات الحسابات
    accounts.forEach(account => {
      headerData.push([
        account.name,
        account.accountNumber,
        getCategoryName(account.categoryId),
        parseFloat(account.balance || 0),
        account.additionalDetails || ''
      ]);
    });
    
    // إنشاء ملف XLSX
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(headerData);
    
    // تنسيق عرض الأعمدة
    ws['!cols'] = [
      { wch: 30 }, // اسم الحساب
      { wch: 20 }, // رقم الحساب
      { wch: 20 }, // التصنيف
      { wch: 18 }, // الرصيد
      { wch: 40 }  // التفاصيل
    ];
    
    XLSX.utils.book_append_sheet(wb, ws, "تقرير الخزينة الشامل");
    XLSX.writeFile(wb, `تقرير_الخزينة_الشامل_${new Date().toISOString().split('T')[0]}.xlsx`);
    
  } catch (error) {
    console.error('خطأ في تصدير الإكسل:', error);
    toast.error('حدث خطأ أثناء تصدير الملف');
  }
};

const exportSingleAccountPDF = async (account) => {
  const toastId = toast.loading('جاري تحضير التقرير...', { duration: 0 });
  
  try {
    let exportTransactions = [];
    let exportSummary = { totalDeposits: 0, totalWithdrawals: 0 };
    
    if (accountExportOptions.dataScope === 'all') {
      // جلب كل المعاملات من قاعدة البيانات
      const url = `${config.API_BASE_URL}/api/banks/bank-accounts/${account.id}/transactions-with-company?loadAll=true`;
      const response = await axios.get(url);
      
      if (response.data && response.data.transactions) {
        exportTransactions = response.data.transactions;
        exportSummary = response.data.summary;
      }
    } else {
      // استخدام البيانات المعروضة حالياً
      exportTransactions = [...accountTransactions];
      exportSummary = {
        totalDeposits: totalDeposits,
        totalWithdrawals: totalWithdrawals
      };
    }
    
    const filteredTransactions = getFilteredAccountTransactionsForExport(exportTransactions);
    
    toast.dismiss(toastId);
    
    const printWindow = window.open('', '_blank');
    const currentDate = new Date();
    
    const htmlContent = `
      <!DOCTYPE html>
      <html dir="rtl" lang="ar">
      <head>
        <meta charset="UTF-8">
        <title>تقرير الحساب - ${account.name}</title>
        <style>
          @page {
            size: A4;
            margin: 15mm;
          }
          
          * { 
            margin: 0; 
            padding: 0; 
            box-sizing: border-box; 
          }
          
          body { 
            font-family: 'Arial', 'Tahoma', sans-serif;
            direction: rtl;
            background: white;
            color: #000;
            font-size: 11px;
            line-height: 1.3;
          }
          
          .header {
            text-align: center;
            margin-bottom: 15px;
            border-bottom: 2px solid #000;
            padding-bottom: 10px;
          }
          
          .account-info {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            gap: 10px;
            margin-bottom: 15px;
          }
          
          .info-box {
            border: 1px solid #000;
            padding: 8px;
            text-align: center;
          }
          
          .info-label {
            font-weight: bold;
            font-size: 10px;
            margin-bottom: 3px;
            color: #666;
          }
          
          .info-value {
            font-size: 12px;
            font-weight: bold;
          }
          
          .summary-section {
            border: 1px solid #000;
            padding: 10px;
            margin-bottom: 15px;
          }
          
          .summary-grid {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            gap: 10px;
            text-align: center;
          }
          
          .transactions-table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 10px;
          }
          
          .transactions-table th,
          .transactions-table td {
            border: 1px solid #000;
            padding: 4px;
            text-align: center;
            font-size: 10px;
          }
          
          .transactions-table th {
            background: #f0f0f0;
            font-weight: bold;
          }
          
          .transactions-table tr:nth-child(even) {
            background: #f9f9f9;
          }
          
          .positive { color: #0D7C0D; }
          .negative { color: #C41E3A; }
          
          .page-break {
            page-break-before: always;
          }
        </style>
      </head>
      <body>
        <div class="header">
          <h2>تقرير الحساب المصرفي</h2>
          <h3>${account.name}</h3>
          <p>تاريخ التقرير: ${formatDateForReport(currentDate)} | عدد المعاملات: ${filteredTransactions.length}</p>
        </div>

        <div class="account-info">
          <div class="info-box">
            <div class="info-label">اسم الحساب</div>
            <div class="info-value">${account.name}</div>
          </div>
          <div class="info-box">
            <div class="info-label">رقم الحساب</div>
            <div class="info-value">${account.accountNumber}</div>
          </div>
          <div class="info-box">
            <div class="info-label">التصنيف</div>
            <div class="info-value">${getCategoryName(account.categoryId)}</div>
          </div>
        </div>

        ${accountExportOptions.includeSummary ? `
        <div class="summary-section">
          <h4 style="text-align: center; margin-bottom: 10px;">ملخص الحساب</h4>
          <div class="summary-grid">
            <div style="border: 1px solid #ccc; padding: 8px;">
              <div class="info-label">الرصيد الحالي</div>
              <div class="info-value ${parseFloat(account.balance) >= 0 ? 'positive' : 'negative'}">${formatBalance(account.balance)}</div>
            </div>
            <div style="border: 1px solid #ccc; padding: 8px;">
              <div class="info-label">إجمالي الإيداعات</div>
              <div class="info-value positive">${formatBalance(exportSummary.totalDeposits)}</div>
            </div>
            <div style="border: 1px solid #ccc; padding: 8px;">
              <div class="info-label">إجمالي السحوبات</div>
              <div class="info-value negative">${formatBalance(exportSummary.totalWithdrawals)}</div>
            </div>
          </div>
        </div>
        ` : ''}

        ${accountExportOptions.includeTransactions && filteredTransactions.length > 0 ? `
        <div>
          <h4 style="text-align: center; margin: 15px 0 10px 0; border-bottom: 1px solid #000; padding-bottom: 5px;">سجل المعاملات</h4>
          <table class="transactions-table">
            <thead>
              <tr>
                <th style="width: 15%;">التاريخ</th>
                <th style="width: 12%;">النوع</th>
                <th style="width: 15%;">المبلغ</th>
                <th style="width: 15%;">الرصيد</th>
                <th style="width: 43%;">التفاصيل</th>
              </tr>
            </thead>
            <tbody>
              ${filteredTransactions.map((transaction, index) => `
                <tr>
                  <td style="font-size: 9px;">${formatDate(transaction.date).split(' - ')[0]}</td>
                  <td>${
                    transaction.type.toLowerCase() === 'deposit' || transaction.type.toLowerCase() === 'إيداع' ? 'إيداع' : 
                    transaction.type.toLowerCase() === 'adjustment' ? 'تعديل' : 'سحب'
                  }</td>
                  <td class="${
                    transaction.type.toLowerCase() === 'deposit' || transaction.type.toLowerCase() === 'إيداع' ? 'positive' : 'negative'
                  }">${formatBalance(transaction.amount)}</td>
                  <td>${formatBalance(transaction.balance)}</td>
                  <td style="text-align: right; font-size: 9px;">
                    ${transaction.companyDetails ? `
                      ${transaction.companyDetails.categoryName}: 
                      ${(transaction.companyDetails.description || transaction.companyDetails.notes || '').substring(0, 50)}
                    ` : (transaction.notes || '-').substring(0, 50)}
                  </td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </div>
        ` : ''}

        <div style="position: fixed; bottom: 10mm; left: 15mm; right: 15mm; text-align: center; font-size: 9px; color: #666; border-top: 1px solid #ccc; padding-top: 5px;">
          تم إنشاء هذا التقرير بواسطة نظام إدارة الخزينة والمحافظ | ${currentDate.toLocaleString('ar-EG')}
        </div>
      </body>
      </html>
    `;
    
    printWindow.document.write(htmlContent);
    printWindow.document.close();
    
    printWindow.onload = () => {
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      }, 500);
    };
    
  } catch (error) {
    toast.dismiss(toastId);
    console.error('خطأ في تصدير التقرير:', error);
    toast.error('حدث خطأ أثناء تصدير التقرير');
  }
};

// دالة فلترة معاملات الحساب حسب الخيارات
const getFilteredAccountTransactions = (transactions) => {
  let filtered = [...transactions];
  
  // فلترة حسب النوع
  if (accountExportOptions.selectedTypes.length > 0) {
    filtered = filtered.filter(t => {
      const type = t.type.toLowerCase();
      return accountExportOptions.selectedTypes.some(selectedType => {
        if (selectedType === 'deposit') return type === 'deposit' || type === 'إيداع';
        if (selectedType === 'withdrawal') return type === 'withdrawal' || type === 'سحب';
        if (selectedType === 'adjustment') return type === 'adjustment' || type === 'تعديل';
        return false;
      });
    });
  }
  
  // فلترة حسب التاريخ
  if (accountExportOptions.dateRange === 'custom') {
    if (accountExportOptions.customStartDate) {
      filtered = filtered.filter(t => new Date(t.date) >= new Date(accountExportOptions.customStartDate));
    }
    if (accountExportOptions.customEndDate) {
      filtered = filtered.filter(t => new Date(t.date) <= new Date(accountExportOptions.customEndDate));
    }
  }
  
  return filtered.sort((a, b) => new Date(b.date) - new Date(a.date));
};

const exportSingleAccountExcel = async (account) => {
  const toastId = toast.loading('جاري تحضير ملف Excel...', { duration: 0 });
  
  try {
    // جلب كل المعاملات للتصدير
    const url = `${config.API_BASE_URL}/api/banks/bank-accounts/${account.id}/transactions-with-company?loadAll=true`;
    const response = await axios.get(url);
    
    let exportTransactions = [];
    let exportSummary = { totalDeposits: 0, totalWithdrawals: 0 };
    
    if (response.data && response.data.transactions) {
      exportTransactions = response.data.transactions;
      exportSummary = response.data.summary;
    }
    
    const filteredTransactions = getFilteredAccountTransactionsForExport(exportTransactions);
    
    toast.dismiss(toastId);
    
    const headerData = [
      [`تقرير الحساب المصرفي: ${account.name}`],
      [`رقم الحساب: ${account.accountNumber}`],
      [`التصنيف: ${getCategoryName(account.categoryId)}`],
      [`تاريخ التقرير: ${formatDateForReport(new Date())}`],
      [`عدد المعاملات: ${filteredTransactions.length}`],
      [], // سطر فارغ
    ];
    
    if (accountExportOptions.includeSummary) {
      headerData.push(
        [`ملخص الحساب:`],
        [`البيان`, `القيمة`],
        [`الرصيد الحالي`, parseFloat(account.balance || 0)],
        [`إجمالي الإيداعات`, parseFloat(exportSummary.totalDeposits || 0)],
        [`إجمالي السحوبات`, parseFloat(exportSummary.totalWithdrawals || 0)],
        [] // سطر فارغ
      );
    }
    
    if (accountExportOptions.includeTransactions) {
      headerData.push(
        [`سجل المعاملات:`],
        [`التاريخ`, `النوع`, `المبلغ (جنيه)`, `الرصيد (جنيه)`, `التفاصيل`]
      );
      
      filteredTransactions.forEach(transaction => {
        headerData.push([
          formatDate(transaction.date),
          transaction.type.toLowerCase() === 'deposit' || transaction.type.toLowerCase() === 'إيداع' ? 'إيداع' : 
          transaction.type.toLowerCase() === 'adjustment' ? 'تعديل' : 'سحب',
          parseFloat(transaction.amount || 0),
          parseFloat(transaction.balance || 0),
          transaction.companyDetails ? 
            `${transaction.companyDetails.categoryName}: ${transaction.companyDetails.description || transaction.companyDetails.notes || ''}` :
            transaction.notes || ''
        ]);
      });
    }
    
    // إنشاء ملف XLSX
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(headerData);
    
    // تنسيق عرض الأعمدة
    ws['!cols'] = [
      { wch: 25 }, // التاريخ
      { wch: 15 }, // النوع
      { wch: 18 }, // المبلغ
      { wch: 18 }, // الرصيد
      { wch: 50 }  // التفاصيل
    ];
    
    XLSX.utils.book_append_sheet(wb, ws, `تقرير_${account.name}`);
    XLSX.writeFile(wb, `تقرير_الحساب_${account.name}_${new Date().toISOString().split('T')[0]}.xlsx`);
    
  } catch (error) {
    toast.dismiss(toastId);
    console.error('خطأ في تصدير تقرير الحساب:', error);
    toast.error('حدث خطأ أثناء تصدير تقرير الحساب');
  }
};

const exportAllTransactionsPDF = async () => {
  const toastId = toast.loading('جاري تحضير تقرير المعاملات...', { duration: 0 });
  
  try {
    let exportTransactions = [];
    
    if (transactionsExportOptions.dataScope === 'all') {
      // جلب كل المعاملات من قاعدة البيانات
      const url = `${config.API_BASE_URL}/api/banks/all-transactions?loadAll=true`;
      const response = await axios.get(url);
      
      if (response.data && response.data.transactions) {
        exportTransactions = response.data.transactions;
      }
    } else {
      // استخدام البيانات المعروضة حالياً
      exportTransactions = [...allTransactions];
    }
    
    const filteredTransactions = getFilteredAllTransactionsForExport(exportTransactions);
    
    toast.dismiss(toastId);
    
    const printWindow = window.open('', '_blank');
    const currentDate = new Date();
    
    const htmlContent = `
      <!DOCTYPE html>
      <html dir="rtl" lang="ar">
      <head>
        <meta charset="UTF-8">
        <title>سجل المعاملات الشامل</title>
        <style>
          @page {
            size: A4;
            margin: 10mm 5mm;
          }
          
          * { 
            margin: 0; 
            padding: 0; 
            box-sizing: border-box; 
          }
          
          body { 
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            direction: rtl;
            background: white;
            color: black;
            font-size: 16px;
            line-height: 1.4;
          }
          
          .print-container {
            max-width: 100%;
            margin: 0;
            background: white;
            padding: 8px;
          }
          
          .report-header {
            text-align: center;
            margin-bottom: 20px;
            border-bottom: 3px solid black;
            padding-bottom: 15px;
          }
          
          .company-name {
            font-size: 32px;
            font-weight: bold;
            color: black;
            margin-bottom: 8px;
          }
          
          .report-title {
            font-size: 24px;
            color: black;
            margin-bottom: 8px;
          }
          
          .report-date {
            font-size: 18px;
            color: black;
          }
          
          .summary-section {
            background: white;
            border: 2px solid black;
            border-radius: 8px;
            padding: 15px;
            margin-bottom: 20px;
          }
          
          .summary-title {
            font-size: 24px;
            font-weight: bold;
            color: black;
            margin-bottom: 15px;
            text-align: center;
            border-bottom: 1px solid black;
            padding-bottom: 8px;
          }
          
          .summary-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 15px;
            text-align: center;
          }
          
          .summary-item {
            background: white;
            padding: 12px;
            border: 1px solid black;
            border-radius: 6px;
          }
          
          .summary-label {
            font-weight: bold;
            color: black;
            margin-bottom: 6px;
            font-size: 14px;
          }
          
          .summary-value {
            font-size: 18px;
            font-weight: bold;
            color: black;
          }
          
          .positive { color: #0F7B0F; }
          .negative { color: #B91C1C; }
          
          .transactions-section {
            margin-top: 20px;
          }
          
          .section-title {
            font-size: 18px;
            font-weight: bold;
            color: black;
            margin-bottom: 15px;
            text-align: center;
            border-bottom: 2px solid black;
            padding-bottom: 8px;
          }
          
          .table-container {
            overflow-x: auto;
          }
          
          table { 
            width: 100%; 
            border-collapse: collapse;
            background: white;
            border: 2px solid black;
          }
          
          th, td { 
            padding: 8px 6px;
            text-align: center;
            border: 1px solid black;
            font-size: 11px;
            color: black;
          }
          
          th { 
            background: #f0f0f0;
            font-weight: bold;
            color: black;
            font-size: 13px;
          }
          
          tr:nth-child(even) { 
            background: #f8f8f8; 
          }
          
          tr:nth-child(odd) { 
            background: white; 
          }
          
          .footer {
            margin-top: 20px;
            text-align: center;
            color: black;
            font-size: 14px;
            border-top: 1px solid black;
            padding-top: 10px;
          }
          
          @media print {
            body { 
              font-size: 12px;
            }
            
            .print-container {
              padding: 5px;
            }
            
            .company-name {
              font-size: 24px;
            }
            
            .report-title {
              font-size: 20px;
            }
            
            .report-date {
              font-size: 14px;
            }
            
            th, td { 
              padding: 6px 3px; 
              font-size: 9px;
            }
            
            th {
              font-size: 11px;
            }
            
            @page {
              margin: 8mm 3mm;
            }
          }
        </style>
      </head>
      <body>
        <div class="print-container">
          <div class="report-header">
            <div class="company-name">سجل المعاملات الشامل</div>
            <div class="report-title">تقرير جميع معاملات الخزينة</div>
            <div class="report-date">
              تاريخ التقرير: ${formatDateForReport(currentDate)} | 
              عدد المعاملات: ${filteredTransactions.length}
            </div>
          </div>

          ${transactionsExportOptions.includeSummary ? `
          <div class="summary-section">
            <div class="summary-title">ملخص المعاملات</div>
            <div class="summary-grid">
              <div class="summary-item">
                <div class="summary-label">إجمالي المعاملات</div>
                <div class="summary-value">${filteredTransactions.length}</div>
              </div>
              <div class="summary-item">
                <div class="summary-label">معاملات الإيداع</div>
                <div class="summary-value positive">${filteredTransactions.filter(t => t.type.toLowerCase() === 'إيداع' || t.type.toLowerCase() === 'deposit').length}</div>
              </div>
              <div class="summary-item">
                <div class="summary-label">معاملات السحب</div>
                <div class="summary-value negative">${filteredTransactions.filter(t => t.type.toLowerCase() === 'سحب' || t.type.toLowerCase() === 'withdrawal').length}</div>
              </div>
              <div class="summary-item">
                <div class="summary-label">معاملات التعديل</div>
                <div class="summary-value">${filteredTransactions.filter(t => t.type.toLowerCase() === 'تعديل' || t.type.toLowerCase() === 'adjustment').length}</div>
              </div>
            </div>
          </div>
          ` : ''}

          <div class="transactions-section">
            <div class="section-title">سجل المعاملات التفصيلي</div>
            <div class="table-container">
              <table>
                <thead>
                  <tr>
                    <th style="width: 40px;">م</th>
                    <th style="width: 80px;">التاريخ</th>
                    <th style="width: 120px;">اسم الحساب</th>
                    <th style="width: 60px;">النوع</th>
                    <th style="width: 80px;">المبلغ</th>
                    <th style="width: 80px;">الرصيد</th>
                    <th>التفاصيل</th>
                  </tr>
                </thead>
                <tbody>
                  ${filteredTransactions.length === 0 ? `
                    <tr>
                      <td colspan="7" style="text-align: center; padding: 20px; color: #666;">
                        لا توجد معاملات في النطاق المحدد
                      </td>
                    </tr>
                  ` : filteredTransactions.map((transaction, index) => `
                    <tr>
                      <td>${index + 1}</td>
                      <td>${formatDate(transaction.date)}</td>
                      <td style="font-weight: bold;">${transaction.accountName || 'غير محدد'}</td>
                      <td>${
                        transaction.type.toLowerCase() === 'deposit' || transaction.type.toLowerCase() === 'إيداع' ? 'إيداع' : 
                        transaction.type.toLowerCase() === 'adjustment' ? 'تعديل' : 'سحب'
                      }</td>
                      <td class="${
                        transaction.type.toLowerCase() === 'deposit' || transaction.type.toLowerCase() === 'إيداع' ? 'positive' : 'negative'
                      }">${formatAmountForReport(transaction.amount)}</td>
                      <td>${formatAmountForReport(transaction.balance)}</td>
                      <td style="text-align: right; font-size: 10px;">
                        ${transaction.companyDetails ? `
                          <strong>${transaction.companyDetails.categoryName}:</strong> 
                          ${transaction.companyDetails.description || transaction.companyDetails.notes || ''}
                        ` : transaction.notes || '-'}
                      </td>
                    </tr>
                  `).join('')}
                </tbody>
              </table>
            </div>
          </div>

          <div class="footer">
            تم إنشاء هذا التقرير بواسطة نظام إدارة الخزينة والمحافظ | 
            ${currentDate.toLocaleString('ar-EG')}
          </div>
        </div>
      </body>
      </html>
    `;
    
    printWindow.document.write(htmlContent);
    printWindow.document.close();
    
    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    };
    
  } catch (error) {
    toast.dismiss(toastId);
    console.error('خطأ في تصدير التقرير:', error);
    toast.error('حدث خطأ أثناء تصدير التقرير');
  }
};

// دالة فلترة جميع المعاملات حسب الخيارات
const getFilteredAllTransactions = () => {
 let filtered = [...allTransactions];
 
 // فلترة حسب الحسابات المحددة
 if (transactionsExportOptions.selectedAccounts.length > 0) {
   filtered = filtered.filter(t => 
     transactionsExportOptions.selectedAccounts.includes(t.accountName)
   );
 }
 
 // فلترة حسب النوع
 if (transactionsExportOptions.selectedTypes.length > 0) {
   filtered = filtered.filter(t => {
     const type = t.type.toLowerCase();
     return transactionsExportOptions.selectedTypes.some(selectedType => {
       if (selectedType === 'deposit') return type === 'deposit' || type === 'إيداع';
       if (selectedType === 'withdrawal') return type === 'withdrawal' || type === 'سحب';
       if (selectedType === 'adjustment') return type === 'adjustment' || type === 'تعديل';
       return false;
     });
   });
 }
 
 // فلترة حسب التاريخ
 if (transactionsExportOptions.dateRange === 'custom') {
   if (transactionsExportOptions.customStartDate) {
     filtered = filtered.filter(t => new Date(t.date) >= new Date(transactionsExportOptions.customStartDate));
   }
   if (transactionsExportOptions.customEndDate) {
     filtered = filtered.filter(t => new Date(t.date) <= new Date(transactionsExportOptions.customEndDate));
   }
 }
 
 return filtered.sort((a, b) => new Date(b.date) - new Date(a.date));
};

const exportAllTransactionsExcel = async () => {
  const toastId = toast.loading('جاري تحضير ملف Excel...', { duration: 0 });
  
  try {
    // جلب كل المعاملات للتصدير
    const url = `${config.API_BASE_URL}/api/banks/all-transactions?loadAll=true`;
    const response = await axios.get(url);
    
    let exportTransactions = [];
    if (response.data && response.data.transactions) {
      exportTransactions = response.data.transactions;
    }
    
    const filteredTransactions = getFilteredAllTransactionsForExport(exportTransactions);
    
    toast.dismiss(toastId);
    
    const headerData = [
      [`سجل المعاملات الشامل للخزينة`],
      [`تاريخ التقرير: ${formatDateForReport(new Date())}`],
      [`عدد المعاملات: ${filteredTransactions.length}`],
      [], // سطر فارغ
    ];
    
    if (transactionsExportOptions.includeSummary) {
      headerData.push(
        [`ملخص المعاملات:`],
        [`البيان`, `العدد`],
        [`إجمالي المعاملات`, `${filteredTransactions.length}`],
        [`معاملات الإيداع`, `${filteredTransactions.filter(t => t.type.toLowerCase() === 'إيداع' || t.type.toLowerCase() === 'deposit').length}`],
        [`معاملات السحب`, `${filteredTransactions.filter(t => t.type.toLowerCase() === 'سحب' || t.type.toLowerCase() === 'withdrawal').length}`],
        [`معاملات التعديل`, `${filteredTransactions.filter(t => t.type.toLowerCase() === 'تعديل' || t.type.toLowerCase() === 'adjustment').length}`],
        [] // سطر فارغ
      );
    }
    
    headerData.push(
      [`سجل المعاملات التفصيلي:`],
      [`التاريخ`, `الوقت`, `اسم الحساب`, `النوع`, `المبلغ (جنيه)`, `الرصيد (جنيه)`, `التفاصيل`]
    );
    
    filteredTransactions.forEach(transaction => {
      const dateObj = transaction.date ? new Date(transaction.date) : null;
      
      const formattedDateOnly = dateObj ? dateObj.toLocaleDateString('ar-EG', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        calendar: 'gregory'
      }) : '-';
      
      const formattedTimeOnly = dateObj ? dateObj.toLocaleTimeString('ar-EG', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      }) : '-';
      
      headerData.push([
        formattedDateOnly,
        formattedTimeOnly,
        transaction.accountName || 'غير محدد',
        transaction.type.toLowerCase() === 'deposit' || transaction.type.toLowerCase() === 'إيداع' ? 'إيداع' : 
        transaction.type.toLowerCase() === 'adjustment' ? 'تعديل' : 'سحب',
        parseFloat(transaction.amount || 0),
        parseFloat(transaction.balance || 0),
        transaction.companyDetails ? 
          `${transaction.companyDetails.categoryName}: ${transaction.companyDetails.description || transaction.companyDetails.notes || ''}` :
          transaction.notes || ''
      ]);
    });
    
    // إنشاء ملف XLSX
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(headerData);
    
    ws['!cols'] = [
      { wch: 18 }, // التاريخ
      { wch: 14 }, // الوقت
      { wch: 25 }, // اسم الحساب
      { wch: 15 }, // النوع
      { wch: 18 }, // المبلغ
      { wch: 18 }, // الرصيد
      { wch: 50 }  // التفاصيل
    ];
    
    XLSX.utils.book_append_sheet(wb, ws, "سجل المعاملات الشامل");
    XLSX.writeFile(wb, `سجل_المعاملات_الشامل_${new Date().toISOString().split('T')[0]}.xlsx`);
    
  } catch (error) {
    toast.dismiss(toastId);
    console.error('خطأ في تصدير سجل المعاملات:', error);
    toast.error('حدث خطأ أثناء تصدير الملف');
  }
};

// دالة تنفيذ التصدير العام
const executeGeneralExport = () => {
 if (exportOptions.format === 'pdf') {
   exportAllAccountsPDF();
 } else if (exportOptions.format === 'excel') {
   exportAllAccountsExcel();
 }
 setIsExportModalOpen(false);
 toast.success('تم تصدير التقرير بنجاح!');
};

const executeAccountExport = async () => {
  if (accountExportOptions.format === 'pdf') {
    await exportSingleAccountPDF(exportingAccount);
  } else if (accountExportOptions.format === 'excel') {
    await exportSingleAccountExcel(exportingAccount);
  }
  setIsAccountExportModalOpen(false);
  toast.success('تم تصدير تقرير الحساب بنجاح!');
};

const executeTransactionsExport = async () => {
  if (transactionsExportOptions.format === 'pdf') {
    await exportAllTransactionsPDF();
  } else if (transactionsExportOptions.format === 'excel') {
    await exportAllTransactionsExcel();
  }
  setIsTransactionsExportModalOpen(false);
  toast.success('تم تصدير سجل المعاملات بنجاح!');
};

// دالة فتح نافذة التصدير الخاص بحساب معين
const openAccountExportModal = (account) => {
 setExportingAccount(account);
 setIsAccountExportModalOpen(true);
};



// دالة فلترة معاملات الحساب للتصدير (تعمل على البيانات المجلبة للتصدير)
const getFilteredAccountTransactionsForExport = (transactions) => {
  let filtered = [...transactions];
  
  // فلترة حسب النوع
  if (accountExportOptions.selectedTypes.length > 0) {
    filtered = filtered.filter(t => {
      const type = t.type.toLowerCase();
      return accountExportOptions.selectedTypes.some(selectedType => {
        if (selectedType === 'deposit') return type === 'deposit' || type === 'إيداع';
        if (selectedType === 'withdrawal') return type === 'withdrawal' || type === 'سحب';
        if (selectedType === 'adjustment') return type === 'adjustment' || type === 'تعديل';
        return false;
      });
    });
  }
  
  // فلترة حسب التاريخ
  if (accountExportOptions.dateRange === 'custom') {
    if (accountExportOptions.customStartDate) {
      filtered = filtered.filter(t => new Date(t.date) >= new Date(accountExportOptions.customStartDate));
    }
    if (accountExportOptions.customEndDate) {
      filtered = filtered.filter(t => new Date(t.date) <= new Date(accountExportOptions.customEndDate));
    }
  }
  
  return filtered.sort((a, b) => new Date(b.date) - new Date(a.date));
};

// دالة فلترة جميع المعاملات للتصدير (تعمل على البيانات المجلبة للتصدير)
const getFilteredAllTransactionsForExport = (transactions) => {
  let filtered = [...transactions];
  
  // فلترة حسب الحسابات المحددة
  if (transactionsExportOptions.selectedAccounts.length > 0) {
    filtered = filtered.filter(t => 
      transactionsExportOptions.selectedAccounts.includes(t.accountName)
    );
  }
  
  // فلترة حسب النوع
  if (transactionsExportOptions.selectedTypes.length > 0) {
    filtered = filtered.filter(t => {
      const type = t.type.toLowerCase();
      return transactionsExportOptions.selectedTypes.some(selectedType => {
        if (selectedType === 'deposit') return type === 'deposit' || type === 'إيداع';
        if (selectedType === 'withdrawal') return type === 'withdrawal' || type === 'سحب';
        if (selectedType === 'adjustment') return type === 'adjustment' || type === 'تعديل';
        return false;
      });
    });
  }
  
  // فلترة حسب التاريخ
  if (transactionsExportOptions.dateRange === 'custom') {
    if (transactionsExportOptions.customStartDate) {
      filtered = filtered.filter(t => new Date(t.date) >= new Date(transactionsExportOptions.customStartDate));
    }
    if (transactionsExportOptions.customEndDate) {
      filtered = filtered.filter(t => new Date(t.date) <= new Date(transactionsExportOptions.customEndDate));
    }
  }
  
  return filtered.sort((a, b) => new Date(b.date) - new Date(a.date));
};


// العودة بالمكون
return (
  <div className="min-h-screen bg-gray-50 py-6 treasury-mobile-page" dir="rtl">
    <style>{`
      @media (max-width: 768px) {
        .treasury-mobile-page {
          padding-top: 0 !important;
          overflow-x: hidden !important;
          background: #f6f8fb !important;
        }
        .treasury-mobile-page * {
          max-width: 100%;
          box-sizing: border-box;
        }
        .treasury-mobile-page .max-w-7xl {
          padding-left: 12px !important;
          padding-right: 12px !important;
        }
        .treasury-mobile-page .bg-white.rounded-lg.shadow-md.p-6.mb-6:first-of-type {
          border-radius: 0 0 26px 26px !important;
          padding: 14px 14px 16px !important;
          margin: 0 -12px 12px !important;
          position: sticky;
          top: 0;
          z-index: 20;
          box-shadow: 0 10px 30px rgba(15, 23, 42, 0.12) !important;
        }
        .treasury-mobile-page .bg-white.rounded-lg.shadow-md.p-6.mb-6:first-of-type > div {
          display: flex !important;
          flex-direction: column !important;
          align-items: stretch !important;
          gap: 12px !important;
        }
        .treasury-mobile-page h1 {
          font-size: 22px !important;
          line-height: 1.45 !important;
          justify-content: center !important;
          text-align: center !important;
          margin: 0 !important;
        }
        .treasury-mobile-page h1 svg {
          width: 24px !important;
          height: 24px !important;
        }
        .treasury-mobile-page .bg-white.rounded-lg.shadow-md.p-6.mb-6:first-of-type .flex.gap-2.items-center {
          display: grid !important;
          grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
          gap: 8px !important;
          width: 100% !important;
        }
        .treasury-mobile-page .bg-white.rounded-lg.shadow-md.p-6.mb-6:first-of-type .flex.gap-2.items-center button {
          width: 100% !important;
          min-height: 44px !important;
          justify-content: center !important;
          border-radius: 14px !important;
          padding: 10px 8px !important;
          font-size: 13px !important;
          white-space: normal !important;
        }
        .treasury-mobile-page .bg-gradient-to-r {
          border-radius: 22px !important;
          padding: 18px !important;
          margin-bottom: 14px !important;
        }
        .treasury-mobile-page .bg-gradient-to-r > div {
          align-items: stretch !important;
          text-align: center !important;
        }
        .treasury-mobile-page .bg-gradient-to-r .text-3xl {
          font-size: 28px !important;
          background: rgb(var(--bg-white, 255 255 255) / .16) !important;
          border-radius: 18px !important;
          padding: 12px !important;
        }
        .treasury-mobile-page .bg-white.rounded-lg.shadow-md.p-6.mb-6,
        .treasury-mobile-page .bg-white.rounded-lg.shadow-md.p-6 {
          border-radius: 22px !important;
          padding: 14px !important;
          margin-bottom: 14px !important;
        }
        .treasury-mobile-page .flex.flex-wrap.gap-2 {
          display: flex !important;
          flex-wrap: nowrap !important;
          overflow-x: auto !important;
          gap: 8px !important;
          padding-bottom: 8px !important;
          -webkit-overflow-scrolling: touch;
        }
        .treasury-mobile-page .flex.flex-wrap.gap-2 > * {
          flex: 0 0 auto !important;
        }
        .treasury-mobile-page input,
        .treasury-mobile-page select,
        .treasury-mobile-page textarea {
          min-height: 46px !important;
          border-radius: 14px !important;
          font-size: 16px !important;
        }
        .treasury-mobile-page .fixed.inset-y-0.right-0 {
          inset: 0 !important;
          width: 100vw !important;
          height: 100dvh !important;
          z-index: 70 !important;
          border-radius: 0 !important;
        }
        .treasury-mobile-page .fixed.inset-y-0.right-0.translate-x-full {
          transform: translateX(100%) !important;
        }
        .treasury-mobile-page .fixed.inset-y-0.right-0.translate-x-0 {
          transform: translateX(0) !important;
        }
        .treasury-mobile-page .fixed.bottom-10.right-6 {
          bottom: 18px !important;
          right: 18px !important;
          z-index: 45 !important;
          border-radius: 18px !important;
          box-shadow: 0 14px 30px rgba(37, 99, 235, .35) !important;
        }
        .treasury-mobile-page .fixed.inset-0.bg-black {
          align-items: stretch !important;
          justify-content: stretch !important;
          padding: 0 !important;
          z-index: 80 !important;
        }
        .treasury-mobile-page .fixed.inset-0.bg-black > div {
          width: 100vw !important;
          max-width: none !important;
          min-height: 100dvh !important;
          max-height: 100dvh !important;
          margin: 0 !important;
          border-radius: 0 !important;
          overflow-y: auto !important;
          padding: 16px !important;
        }
        .treasury-mobile-page .fixed.inset-0.bg-black > div > h2 {
          position: sticky !important;
          top: 0 !important;
          background: rgb(var(--bg-white, 255 255 255)) !important;
          z-index: 2 !important;
          margin: -16px -16px 16px !important;
          padding: 16px !important;
          border-bottom: 1px solid rgb(var(--border-gray-200, 229 231 235)) !important;
          font-size: 20px !important;
          line-height: 1.4 !important;
        }
        .treasury-mobile-page .fixed.inset-0.bg-black .grid {
          grid-template-columns: minmax(0, 1fr) !important;
          gap: 12px !important;
        }
        .treasury-mobile-page .fixed.inset-0.bg-black .flex.justify-end.gap-3,
        .treasury-mobile-page .fixed.inset-0.bg-black .flex.gap-3.justify-end,
        .treasury-mobile-page .fixed.inset-0.bg-black .flex.space-x-3 {
          position: sticky !important;
          bottom: 0 !important;
          background: rgb(var(--bg-white, 255 255 255)) !important;
          margin: 16px -16px -16px !important;
          padding: 12px 16px !important;
          border-top: 1px solid rgb(var(--border-gray-200, 229 231 235)) !important;
          display: grid !important;
          grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
          gap: 10px !important;
          z-index: 3 !important;
        }
        .treasury-mobile-page .fixed.inset-0.bg-black .flex.justify-end.gap-3 button,
        .treasury-mobile-page .fixed.inset-0.bg-black .flex.gap-3.justify-end button,
        .treasury-mobile-page .fixed.inset-0.bg-black .flex.space-x-3 button {
          width: 100% !important;
          min-height: 46px !important;
          justify-content: center !important;
        }
        .treasury-mobile-page table {
          min-width: 760px;
        }
        .treasury-mobile-page .overflow-x-auto {
          -webkit-overflow-scrolling: touch;
        }
        .treasury-mobile-page .treasury-mobile-account-card {
          border-radius: 22px;
          background: rgb(var(--bg-white, 255 255 255));
          box-shadow: 0 10px 28px rgba(15, 23, 42, .08);
          border: 1px solid #e9eef8;
          overflow: hidden;
        }
        .treasury-mobile-page .treasury-mobile-account-card::before {
          content: '';
          display: block;
          height: 5px;
          background: linear-gradient(90deg, rgb(var(--bg-blue-600, 42 69 125)), rgb(var(--bg-teal-500, 20 184 166)));
        }
        .treasury-mobile-page .treasury-mobile-card-actions {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 8px;
        }
        .treasury-mobile-page .treasury-mobile-card-actions button {
          min-height: 42px;
          border-radius: 14px;
          justify-content: center;
        }
      }
    `}</style>
    <div className="flex flex-col md:flex-row">
{/* الشاشة الجانبية للمعاملات */}
<div className={`fixed inset-y-0 right-0 transform ${isSidebarOpen ? 'translate-x-0' : 'translate-x-full'} z-30 w-88 md:w-1/4 lg:w-1/5 bg-white shadow-xl transition-transform duration-300 ease-in-out overflow-hidden flex flex-col`}>
  <div className="p-4 bg-blue-600 text-white flex justify-between items-center">
    <h3 className="text-xl font-bold flex items-center">
      <Activity className="ml-2" size={22} />
      سجل المعاملات
    </h3>
    <div className="flex items-center gap-2">
      {/* زر الطباعة السريعة */}
      <button
        onClick={printCurrentTransactions}
        className="text-white hover:bg-blue-700 p-1.5 rounded-full"
        title="طباعة سريعة للمعاملات المعروضة"
        disabled={allTransactions.length === 0}
      >
        <Printer size={18} />
      </button>
      <button
        onClick={() => setIsSidebarOpen(false)}
        className="text-white hover:bg-blue-700 p-1.5 rounded-full"
      >
        <X size={20} />
      </button>
    </div>

    <button
      onClick={() => setIsSidebarOpen(false)}
      className="text-white hover:bg-blue-700 p-1.5 rounded-full"
    >
      <X size={20} />
    </button>
  </div>

  {/* خيارات عرض المعاملات - جديد */}
  <div className="p-4 bg-gray-50 border-b border-gray-200">
    <div className="mb-3">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        عدد المعاملات في الصفحة
      </label>
      <div className="flex gap-2">
        {[35, 50, 100].map((limit) => (
          <button
            key={limit}
            onClick={() => handleTransactionsPerPageChange(limit)}
            className={`px-3 py-2 text-sm rounded-md transition-colors ${
              transactionsPerPage === limit
                ? 'bg-blue-600 text-white'
                : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
            }`}
          >
            {limit}
          </button>
        ))}
      </div>
    </div>
    
    {/* إحصائيات سريعة */}
    <div className="text-sm text-blue-800">
      <p>عرض {allTransactions.length} من أصل {allTransactionsPagination.totalTransactions} معاملة</p>
      {!showAllGlobalTransactions && allTransactionsPagination.totalTransactions > allTransactions.length && (
        <p className="mt-1 text-xs text-blue-600">
          يتم عرض {transactionsPerPage} معاملة لكل صفحة
        </p>
      )}
    </div>
  </div>

  <div className="flex-1 overflow-y-auto p-4">
    {/* إحصائيات سريعة */}
    <div className="mb-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
      <div className="text-sm text-blue-800">
        <p>عرض {allTransactions.length} من أصل {allTransactionsPagination.totalTransactions} معاملة</p>
        {!showAllGlobalTransactions && allTransactionsPagination.totalTransactions > allTransactions.length && (
          <p className="mt-1 text-xs text-blue-600">
            يتم عرض أحدث {allTransactionsPagination.limit} معاملة فقط لتحسين الأداء
          </p>
        )}
      </div>
    </div>

    {isAllTransactionsLoading && allTransactions.length === 0 ? (
      <div className="flex justify-center items-center h-full">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-500"></div>
      </div>
    ) : allTransactions.length === 0 ? (
      <div className="text-center py-10">
        <Clipboard className="mx-auto h-12 w-12 text-gray-400 mb-3" />
        <p className="text-gray-500 text-lg">لا توجد معاملات حالياً</p>
      </div>
    ) : (
      <div className="space-y-5">
        {allTransactions.map((transaction, index) => (
          <div 
            key={transaction.id || index} 
            className="border border-gray-200 rounded-lg p-5 bg-white shadow-sm hover:shadow-md transition-shadow"
          >
            <div className="flex justify-between items-start mb-3">
              <div>
                <h4 className="font-bold text-lg text-gray-900 mb-2">{transaction.accountName}</h4>
                <span className={`inline-flex items-center px-3 py-1 rounded text-sm font-medium ${
                  transaction.type.toLowerCase() === 'إيداع' || 
                  transaction.type.toLowerCase() === 'deposit' ? 
                  'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                }`}>
                  {transaction.type.toLowerCase() === 'deposit' ? 'إيداع' : 
                   transaction.type.toLowerCase() === 'إيداع' ? 'إيداع' : 
                   transaction.type.toLowerCase() === 'withdrawal' ? 'سحب' : 
                   transaction.type.toLowerCase() === 'سحب' ? 'سحب' : 
                   transaction.type.toLowerCase() === 'adjustment' ? 'تعديل' : 
                   transaction.type}
                </span>
              </div>
              <div className="text-left">
                <p className={`text-lg font-bold ${
                  transaction.type.toLowerCase() === 'إيداع' || 
                  transaction.type.toLowerCase() === 'deposit' || 
                  transaction.type.toLowerCase() === 'adjustment' ? 
                  'text-green-600' : 'text-red-600'
                }`}>
                  {formatBalance(transaction.amount)}
                </p>
              </div>
            </div>
            
            <div className="mt-3 text-sm text-gray-700">
              <div className="flex justify-between items-center mb-2">
                <span className="font-medium">{formatDate(transaction.date)}</span>
                <span className="bg-gray-100 px-3 py-1 rounded-lg text-gray-700 font-medium">
                  الرصيد: {formatBalance(transaction.balance)}
                </span>
              </div>
              
              {getTransactionClientName(transaction) && (
                <div className="mt-2 bg-emerald-50 p-3 rounded-lg border-r-4 border-emerald-500">
                  <p className="text-emerald-900 font-black">العميل: {getTransactionClientName(transaction)}</p>
                </div>
              )}

              {transaction.companyDetails ? (
                <div className="mt-2 bg-blue-50 p-3 rounded-lg border-r-4 border-blue-500">
                  <p className="text-blue-800 font-medium text-base leading-relaxed">
                    <span className={`font-bold ${
                      transaction.companyDetails.categoryType === 'income' 
                        ? 'text-green-700' 
                        : 'text-blue-700'
                    }`}>
                      {transaction.companyDetails.categoryName}
                    </span>
                    {(transaction.companyDetails.description || transaction.companyDetails.notes) && (
                      <>
                        <span className="text-gray-600 mx-1">:</span>
                        <span className="text-gray-800">
                          {transaction.companyDetails.description || transaction.companyDetails.notes}
                        </span>
                      </>
                    )}
                  </p>
                </div>
              ) : transaction.notes && (
                <div className="mt-2 bg-blue-50 p-3 rounded-lg border-r-4 border-blue-500">
                  <p className="text-blue-800 font-medium text-base leading-relaxed">
                    {transaction.notes}
                  </p>
                </div>
              )}
            </div>
          </div>
        ))}

        {/* نظام Pagination لجميع المعاملات */}
        {allTransactionsPagination.totalPages > 1 && (
          <div className="mt-4 bg-gray-50 rounded-lg p-4 border border-gray-200">
            <div className="flex items-center justify-between mb-3">
              <div className="text-sm text-gray-600">
                صفحة {allTransactionsPagination.currentPage} من {allTransactionsPagination.totalPages}
              </div>
              <div className="text-xs text-gray-500">
                عرض {allTransactions.length} من أصل {allTransactionsPagination.totalTransactions} معاملة
              </div>
            </div>
            
            <div className="flex items-center justify-center gap-2">
              <button
                onClick={() => fetchAllTransactions(1, false)}
                disabled={allTransactionsPagination.currentPage === 1 || isAllTransactionsLoading}
                className="px-3 py-2 rounded border border-gray-300 hover:bg-gray-100 disabled:opacity-50 text-sm"
                title="الصفحة الأولى"
              >
                ««
              </button>
              
              <button
                onClick={() => fetchAllTransactions(allTransactionsPagination.currentPage - 1, false)}
                disabled={!allTransactionsPagination.hasPrevPage || isAllTransactionsLoading}
                className="px-3 py-2 rounded border border-gray-300 hover:bg-gray-100 disabled:opacity-50 text-sm flex items-center gap-1"
              >
                <ChevronRight size={16} />
                السابق
              </button>
              
              <div className="flex gap-1">
                {(() => {
                  const current = allTransactionsPagination.currentPage;
                  const total = allTransactionsPagination.totalPages;
                  const maxVisible = 5;
                  let start = Math.max(1, current - Math.floor(maxVisible / 2));
                  let end = Math.min(total, start + maxVisible - 1);
                  
                  if (end - start + 1 < maxVisible) {
                    start = Math.max(1, end - maxVisible + 1);
                  }
                  
                  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
                })().map(page => (
                  <button
                    key={page}
                    onClick={() => fetchAllTransactions(page, false)}
                    disabled={isAllTransactionsLoading}
                    className={`px-3 py-2 rounded text-sm transition-colors ${
                      page === allTransactionsPagination.currentPage
                        ? 'bg-blue-600 text-white border border-blue-600'
                        : 'border border-gray-300 hover:bg-gray-100 disabled:opacity-50'
                    }`}
                  >
                    {page}
                  </button>
                ))}
              </div>
              
              <button
                onClick={() => fetchAllTransactions(allTransactionsPagination.currentPage + 1, false)}
                disabled={!allTransactionsPagination.hasNextPage || isAllTransactionsLoading}
                className="px-3 py-2 rounded border border-gray-300 hover:bg-gray-100 disabled:opacity-50 text-sm flex items-center gap-1"
              >
                التالي
                <ChevronLeft size={16} />
              </button>
              
              <button
                onClick={() => fetchAllTransactions(allTransactionsPagination.totalPages, false)}
                disabled={allTransactionsPagination.currentPage === allTransactionsPagination.totalPages || isAllTransactionsLoading}
                className="px-3 py-2 rounded border border-gray-300 hover:bg-gray-100 disabled:opacity-50 text-sm"
                title="الصفحة الأخيرة"
              >
                »»
              </button>
            </div>

            {/* معلومات إضافية عن العرض */}
            <div className="mt-3 text-center text-xs text-gray-500 border-t pt-2">
              يتم عرض {transactionsPerPage} معاملة في كل صفحة • 
              إجمالي الصفحات: {allTransactionsPagination.totalPages}
            </div>
          </div>
        )}
      </div>
    )}
  </div>
  
  <div className="p-4 bg-gray-100 border-t">
  <div className="flex gap-2 mb-2">
    <button
      onClick={printCurrentTransactions}
      disabled={allTransactions.length === 0}
      className="flex-1 bg-gray-600 hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed text-white py-2 rounded-lg flex items-center justify-center text-sm font-medium"
    >
      <Printer className="ml-2" size={16} />
      طباعة سريعة
    </button>
  </div>
  
  <button
    onClick={() => fetchAllTransactions(1, false)}
    className="w-full bg-blue-500 hover:bg-blue-600 text-white py-3 rounded-lg flex items-center justify-center text-base font-medium"
  >
    <RefreshCw className="ml-2" size={18} />
    تحديث المعاملات
  </button>
</div>
</div>
      
      {/* زر فتح/إغلاق الشاشة الجانبية */}
      <button
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        className={`fixed bottom-10 right-6 z-40 bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-all ${isSidebarOpen ? 'right-72 md:right-1/4 lg:right-1/5' : 'right-6'}`}
        title={isSidebarOpen ? 'إغلاق سجل المعاملات' : 'فتح سجل المعاملات'}
      >
        {isSidebarOpen ? <ChevronRight size={24} /> : <Activity size={24} />}
      </button>
      
      {/* المحتوى الرئيسي */}
      <div className={`flex-1 transition-all duration-300 ${isSidebarOpen ? 'md:mr-1/4 lg:mr-1/5' : 'mr-0'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* رأس الصفحة */}
          <div className="bg-white rounded-lg shadow-md p-6 mb-6">
            <div className="flex justify-between items-center">
              <h1 className="text-2xl font-bold text-gray-900 flex items-center">
                <BankIcon className="text-blue-600 ml-2" size={28} />
                إدارة الخزينة و الحسابات والمحافظ
              </h1>
              <div className="flex gap-2 items-center">
                <button 
                  onClick={() => setViewMode(viewMode === 'grid' ? 'list' : 'grid')}
                  className="text-gray-600 hover:text-gray-900 p-2 rounded-full hover:bg-gray-100"
                  title={viewMode === 'grid' ? 'عرض قائمة' : 'عرض شبكة'}
                >
                  {viewMode === 'grid' ? <List size={20} /> : <Grid size={20} />}
                </button>
                <button
  onClick={() => setIsExportModalOpen(true)}
  className="bg-orange-600 hover:bg-orange-700 text-white px-4 py-2 rounded-lg flex items-center gap-2"
  title="تصدير تقرير عام للخزينة"
>
  <FileSpreadsheet size={18} />
  تقرير عام
</button>
<button
  onClick={() => setIsTransactionsExportModalOpen(true)}
  className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg flex items-center gap-2"
  title="تصدير سجل المعاملات"
>
  <Download size={18} />
  سجل المعاملات
</button>


                <button
                  onClick={fetchData}
                  className="text-gray-600 hover:text-gray-900 p-2 rounded-full hover:bg-gray-100"
                  title="تحديث البيانات"
                >
                  <RefreshCw size={20} className={loading ? 'animate-spin' : ''} />
                </button>
                <button 
                  onClick={() => navigate('/')}
                  className="bg-gray-600 hover:bg-gray-700 text-white px-6 py-2.5 rounded-lg transition duration-200"
                >
                  العودة للرئيسية
                </button>
              </div>
            </div>
          </div>

          {/* عرض الرصيد الإجمالي */}
          <div className="bg-gradient-to-r from-blue-500 to-indigo-600 rounded-lg shadow-lg p-6 mb-6 text-white">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <div>
                <h2 className="text-xl font-medium mb-2">الرصيد الإجمالي</h2>
                <p className="text-gray-100 text-sm">إجمالي الرصيد في جميع الحسابات</p>
              </div>
              <div className="text-3xl font-bold mt-4 md:mt-0">
                {formatBalance(totalBalance)}
              </div>
            </div>
          </div>
          
          {/* عرض الحسابات المميزة */}
          {pinnedAccountsList.length > 0 && (
            <div className="mb-6">
              <h2 className="text-lg font-semibold mb-4 flex items-center">
                <Pin className="text-yellow-500 ml-2" size={20} />
                الحسابات المميزة
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {pinnedAccountsList.map((account) => (
                  <div
                    key={`pinned-${account.id}`}
                    className="bg-white border-2 border-yellow-400 rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow"
                  >
                    <div className="p-4">
                      <div className="flex justify-between items-start">
                        <div>
                          <h3 className="font-bold text-lg text-gray-900">{account.name}</h3>
                          <p className="text-sm text-gray-500 mb-1">رقم الحساب: {account.accountNumber}</p>
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                            {getCategoryName(account.categoryId)}
                          </span>
                        </div>
                        <div className="text-left">
                          <p className={`text-lg font-bold ${parseFloat(account.balance || 0) >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                            {formatBalance(account.balance)}
                          </p>
                        </div>
                      </div>
                      
                      <div className="mt-4 pt-4 border-t border-gray-100 flex justify-between">
                        <button
                          onClick={() => viewAccountDetails(account)}
                          className="text-blue-600 hover:text-blue-800 text-sm flex items-center"
                        >
                          <Activity size={16} className="ml-1" />
                          سجل المعاملات
                        </button>
                        
                        <button
  onClick={() => openAccountExportModal(account)}
  className="text-green-600 hover:text-green-800 p-1.5 rounded-full hover:bg-green-50"
  title="تصدير تقرير الحساب"
>
  <FileSpreadsheet size={16} />
</button>

                        <div className="flex space-x-2 rtl:space-x-reverse">
                          <button
                            onClick={() => togglePinAccount(account.id)}
                            className="text-yellow-600 hover:text-yellow-800 p-1.5 rounded-full hover:bg-yellow-50"
                            title="إلغاء تمييز الحساب"
                          >
                            <PinOff size={16} />
                          </button>
                          {canDo('حذف الحساب') && (
                          <button
                            onClick={() => deleteAccount(account.id)}
                            className="text-gray-600 hover:text-red-600 p-1.5 rounded-full hover:bg-red-50"
                            title="حذف الحساب"
                          >
                            <Trash2 size={16} />
                          </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          
          {/* شريط الأدوات والفلاتر */}
          <div className="bg-white rounded-lg shadow-md p-6 mb-6">
            <div className="flex flex-col md:flex-row justify-between gap-4">
              <div className="flex-1">
                <h2 className="text-lg font-semibold mb-4">التصنيفات</h2>
                <div className="flex flex-wrap gap-2">
                  <button
                    onClick={() => handleCategoryChange("all")}
                    className={`px-3 py-2 rounded-lg transition flex items-center ${selectedCategory === null ? 'bg-blue-500 text-white' : 'bg-gray-200 hover:bg-gray-300'}`}
                  >
                    <Layers className="ml-1 h-4 w-4" />
                    <span>الكل</span>
                    <span className="mr-2 bg-white bg-opacity-20 text-xs rounded-full px-2 py-0.5">
                      {accounts.length}
                    </span>
                  </button>
                  
                  {categories.map(category => (
                    <div key={category.id} className="flex items-center">
                      <button
                        onClick={() => handleCategoryChange(category.id)}
                        className={`px-3 py-2 rounded-lg transition flex items-center ${selectedCategory === category.id ? 'bg-blue-500 text-white' : 'bg-gray-200 hover:bg-gray-300'}`}
                      >
                        <span>{category.name}</span>
                        <span className="mr-2 bg-white bg-opacity-20 text-xs rounded-full px-2 py-0.5">
                          {accounts.filter(a => a.categoryId === category.id).length}
                        </span>
                      </button>
               
                      {canDo('حذف الحساب') && (
                      <button
                        onClick={() => deleteCategory(category.id)}
                        className="p-1.5 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-full"
                        title="حذف التصنيف"
                      >
                        <Trash2 size={16} />
                      </button>
                      )}
                    </div>
                  ))}
                  
                  {canDo('إضافة تصنيف جديد') && (
                  <button
                    onClick={() => {
                      setNewCategory({ name: '', description: '' });
                      setEditingCategory(null);
                      setIsCategoryModalOpen(true);
                    }}
                    className="px-3 py-2 rounded-lg bg-green-500 text-white hover:bg-green-600 transition flex items-center"
                  >
                    <Plus className="ml-1 h-4 w-4" />
                    <span>إضافة تصنيف</span>
                  </button>
                  )}
                </div>
              </div>
              
              <div className="flex-1">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="البحث في الحسابات..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                  <Search className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" />
                </div>
                
                <div className="flex items-center justify-between mt-3">
                  <div className="text-sm text-gray-500">
                    {filteredAccounts.length} حساب من أصل {accounts.length}
                  </div>
                  <div>
                    {canDo('إضافة حساب جديد') && (
                    <button
                      onClick={() => {
                        setNewAccount({
                          name: '',
                          accountNumber: '',
                          additionalDetails: '',
                          categoryId: selectedCategory,
                          initialBalance: 0
                        });
                        setIsAccountModalOpen(true);
                      }}
                      className="px-4 py-2 rounded-lg bg-green-500 text-white hover:bg-green-600 transition flex items-center"
                    >
                      <Plus className="ml-1 h-4 w-4" />
                      <span>إضافة حساب جديد</span>
                    </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* قائمة الحسابات */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-xl font-semibold mb-6 flex items-center">
              <BankIcon className="text-blue-600 ml-2" size={24} />
              الحسابات المسجلة
            </h2>
            
            {/* عرض حالة التحميل أو الخطأ */}
            {loading ? (
              <div className="text-center py-10">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
                <p className="text-gray-500">جاري تحميل البيانات...</p>
              </div>
            ) : error ? (
              <div className="bg-red-50 border-l-4 border-red-500 p-4 my-4">
                <div className="flex items-center">
                  <AlertTriangle className="text-red-500 ml-3 flex-shrink-0" />
                  <p className="text-red-700">{error}</p>
                </div>
                <button 
                  onClick={fetchData}
                  className="mt-3 bg-red-100 text-red-700 px-4 py-1 rounded hover:bg-red-200 transition-colors inline-flex items-center"
                >
                  <RefreshCw className="ml-2 h-4 w-4" />
                  إعادة المحاولة
                </button>
              </div>
            ) : filteredAccounts.length === 0 ? (
              <div className="text-center py-10 border-2 border-dashed border-gray-300 rounded-lg">
                <Briefcase className="mx-auto h-12 w-12 text-gray-400 mb-3" />
                <h3 className="text-lg font-medium text-gray-900 mb-1">لا توجد حسابات</h3>
                <p className="text-gray-500 mb-4">لم يتم العثور على أي حسابات تطابق معايير البحث</p>
                <button
                  onClick={() => {
                    setSearch('');
                    setSelectedCategory(null);
                    fetchAccounts();
                  }}
                  className="text-blue-600 hover:text-blue-800 font-medium"
                >
                  عرض جميع الحسابات
                </button>
              </div>
            ) : (
              <>
                <div className="md:hidden space-y-4">
                  {filteredAccounts.map((account) => (
                    <div key={`mobile-${account.id}`} className={`treasury-mobile-account-card ${pinnedAccounts.includes(account.id) ? 'ring-2 ring-yellow-300' : ''}`}>
                      <div className="p-4">
                        <div className="flex items-start justify-between gap-3">
                          <div className="min-w-0 flex-1">
                            <div className="flex items-center gap-2 mb-1">
                              {pinnedAccounts.includes(account.id) && (
                                <span className="bg-yellow-100 text-yellow-700 text-xs px-2 py-1 rounded-full">مميز</span>
                              )}
                              <span className="bg-blue-50 text-blue-700 text-xs px-2 py-1 rounded-full">{getCategoryName(account.categoryId)}</span>
                            </div>
                            <h3 className="font-bold text-lg text-gray-900 truncate">{account.name}</h3>
                            <p className="text-xs text-gray-500 mt-1">رقم الحساب: {account.accountNumber || '-'}</p>
                          </div>
                          <div className="text-left shrink-0">
                            <span className="text-xs text-gray-400 block mb-1">الرصيد</span>
                            <p className={`text-base font-extrabold ${parseFloat(account.balance || 0) >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                              {formatBalance(account.balance)}
                            </p>
                          </div>
                        </div>

                        {account.additionalDetails && (
                          <div className="mt-3 bg-gray-50 rounded-2xl p-3 text-sm text-gray-600 leading-relaxed">
                            {account.additionalDetails}
                          </div>
                        )}

                        <div className="treasury-mobile-card-actions mt-4 pt-4 border-t border-gray-100">
                          <button
                            onClick={() => viewAccountDetails(account)}
                            className="bg-blue-600 text-white px-3 py-2 flex items-center gap-2 font-medium"
                          >
                            <Activity size={16} />
                            سجل المعاملات
                          </button>
                          <button
                            onClick={() => openAccountExportModal(account)}
                            className="bg-green-50 text-green-700 px-3 py-2 flex items-center gap-2 font-medium"
                          >
                            <FileSpreadsheet size={16} />
                            تقرير الحساب
                          </button>
                          <button
                            onClick={() => togglePinAccount(account.id)}
                            className="bg-yellow-50 text-yellow-700 px-3 py-2 flex items-center gap-2 font-medium"
                          >
                            {pinnedAccounts.includes(account.id) ? <PinOff size={16} /> : <Pin size={16} />}
                            {pinnedAccounts.includes(account.id) ? 'إلغاء التمييز' : 'تمييز'}
                          </button>
                          {canDo('حذف الحساب') && (
                            <button
                              onClick={() => deleteAccount(account.id)}
                              className="bg-red-50 text-red-700 px-3 py-2 flex items-center gap-2 font-medium"
                            >
                              <Trash2 size={16} />
                              حذف
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="hidden md:block">
                  {viewMode === 'grid' ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {filteredAccounts.map((account) => (
                    <div
                      key={account.id}
                      className={`bg-white border rounded-lg shadow-sm hover:shadow-md transition-shadow overflow-hidden ${
                        pinnedAccounts.includes(account.id) ? 'border-yellow-400 border-2' : ''
                      }`}
                    >
                      <div className="p-6">
                        <div className="flex justify-between items-start">
                          <div>
                            <h3 className="font-bold text-lg text-gray-900">{account.name}</h3>
                            <p className="text-sm text-gray-500 mb-1">رقم الحساب: {account.accountNumber}</p>
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                              {getCategoryName(account.categoryId)}
                            </span>
                          </div>
                          <div className="text-left">
                            <p className={`text-lg font-bold ${parseFloat(account.balance || 0) >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                              {formatBalance(account.balance)}
                            </p>
                          </div>
                        </div>
                        
                        {account.additionalDetails && (
                          <div className="mt-3 text-sm text-gray-600">
                            <p className="line-clamp-2">{account.additionalDetails}</p>
                          </div>
                        )}
                        
                        <div className="mt-4 pt-4 border-t border-gray-100 flex justify-between">
                          <button
                            onClick={() => viewAccountDetails(account)}
                            className="text-blue-600 hover:text-blue-800 text-sm flex items-center"
                          >
                            <Activity size={16} className="ml-1" />
                            سجل المعاملات
                          </button>
                          
                          <div className="flex space-x-2 rtl:space-x-reverse">
                            <button
                              onClick={() => togglePinAccount(account.id)}
                              className={`p-1.5 rounded-full ${
                                pinnedAccounts.includes(account.id) 
                                ? 'text-yellow-600 hover:text-yellow-800 hover:bg-yellow-50' 
                                 : 'text-gray-600 hover:text-yellow-600 hover:bg-yellow-50'
                               }`}
                               title={pinnedAccounts.includes(account.id) ? "إلغاء تمييز الحساب" : "تمييز الحساب"}
                             >
                               {pinnedAccounts.includes(account.id) ? <PinOff size={16} /> : <Pin size={16} />}
                             </button>
                             {canDo('حذف الحساب') && (
                             <button
                               onClick={() => deleteAccount(account.id)}
                               className="text-gray-600 hover:text-red-600 p-1.5 rounded-full hover:bg-red-50"
                               title="حذف الحساب"
                             >
                               <Trash2 size={16} />
                             </button>
                             )}
                           </div>
                         </div>
                       </div>
                     </div>
                   ))}
                 </div>
               ) : (
                 <div className="overflow-x-auto">
                   <table className="min-w-full divide-y divide-gray-200">
                     <thead className="bg-gray-50">
                       <tr>
                         <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                           الحساب
                         </th>
                         <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                           رقم الحساب
                         </th>
                         <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                           التصنيف
                         </th>
                         <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                           الرصيد
                         </th>
                         <th scope="col" className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                           الإجراءات
                         </th>
                       </tr>
                     </thead>
                     <tbody className="bg-white divide-y divide-gray-200">
                       {filteredAccounts.map((account) => (
                         <tr key={account.id} className={`hover:bg-gray-50 ${pinnedAccounts.includes(account.id) ? 'bg-yellow-50' : ''}`}>
                           <td className="px-6 py-4 whitespace-nowrap">
                             <div className="text-sm font-medium text-gray-900">{account.name}</div>
                             {account.additionalDetails && (
                               <div className="text-xs text-gray-500 mt-1 truncate max-w-xs">
                                 {account.additionalDetails}
                               </div>
                             )}
                           </td>
                           <td className="px-6 py-4 whitespace-nowrap">
                             <div className="text-sm text-gray-500">{account.accountNumber}</div>
                           </td>
                           <td className="px-6 py-4 whitespace-nowrap">
                             <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                               {getCategoryName(account.categoryId)}
                             </span>
                           </td>
                           <td className="px-6 py-4 whitespace-nowrap">
                             <span className={`text-sm font-medium ${parseFloat(account.balance || 0) >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                               {formatBalance(account.balance)}
                             </span>
                           </td>
                           <td className="px-6 py-4 whitespace-nowrap text-center">
                             <div className="flex items-center justify-center space-x-2 rtl:space-x-reverse">
                               <button
                                 onClick={() => viewAccountDetails(account)}
                                 className="text-blue-600 hover:text-blue-900 p-1.5 rounded-full hover:bg-blue-50"
                                 title="سجل المعاملات"
                               >
                                 <Activity size={18} />
                               </button>

                               <button
  onClick={() => openAccountExportModal(account)}
  className="text-green-600 hover:text-green-900 p-1.5 rounded-full hover:bg-green-50"
  title="تصدير تقرير الحساب"
>
  <FileSpreadsheet size={18} />
</button>

                               <button
                                 onClick={() => togglePinAccount(account.id)}
                                 className={`p-1.5 rounded-full ${
                                   pinnedAccounts.includes(account.id) 
                                   ? 'text-yellow-600 hover:text-yellow-800 hover:bg-yellow-50' 
                                   : 'text-gray-600 hover:text-yellow-600 hover:bg-yellow-50'
                                 }`}
                                 title={pinnedAccounts.includes(account.id) ? "إلغاء تمييز الحساب" : "تمييز الحساب"}
                               >
                                 {pinnedAccounts.includes(account.id) ? <PinOff size={18} /> : <Pin size={18} />}
                               </button>
                               {canDo('حذف الحساب') && (
                               <button
                                 onClick={() => deleteAccount(account.id)}
                                 className="text-gray-600 hover:text-red-600 p-1.5 rounded-full hover:bg-red-50"
                                 title="حذف الحساب"
                               >
                                 <Trash2 size={18} />
                               </button>
                               )}
                             </div>
                           </td>
                         </tr>
                       ))}
                     </tbody>
                   </table>
                 </div>
               )}
                </div>
              </>
             )}
           </div>
         </div>
       </div>
     </div>

     {/* مربع حوار إضافة/تعديل تصنيف */}
     {isCategoryModalOpen && (
       <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
         <div className="bg-white w-full max-w-lg rounded-2xl shadow-2xl p-8 m-4">
           <h2 className="text-2xl font-bold mb-6 flex items-center">
             <Layers className="text-blue-600 ml-2" size={24} />
             {editingCategory ? 'تعديل التصنيف' : 'إضافة تصنيف جديد'}
           </h2>
           
           {/* اسم التصنيف */}
           <div className="mb-4">
             <label className="block mb-2 text-sm font-medium text-gray-700">اسم التصنيف</label>
             <input
               type="text"
               value={newCategory.name}
               onChange={(e) => setNewCategory({...newCategory, name: e.target.value})}
               className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
               placeholder="أدخل اسم التصنيف"
             />
           </div>

           {/* وصف التصنيف */}
           <div className="mb-4">
             <label className="block mb-2 text-sm font-medium text-gray-700">وصف التصنيف (اختياري)</label>
             <textarea
               value={newCategory.description}
               onChange={(e) => setNewCategory({...newCategory, description: e.target.value})}
               className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
               placeholder="أدخل وصف التصنيف"
               rows="3"
             />
           </div>

           {/* أزرار الإجراءات */}
           <div className="flex gap-3 justify-end">
             <button
               onClick={resetCategoryForm}
               className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition"
             >
               إلغاء
             </button>
             <button
               onClick={editingCategory ? editCategory : addCategory}
               disabled={loading || !newCategory.name}
               className={`px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition flex items-center gap-2 ${(loading || !newCategory.name) ? 'opacity-50 cursor-not-allowed' : ''}`}
             >
               {loading ? (
                 <>
                   <div className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin ml-1"></div>
                   <span>جاري الحفظ...</span>
                 </>
               ) : (
                 <>
                   <Save size={16} />
                   <span>{editingCategory ? 'تحديث' : 'إضافة'}</span>
                 </>
               )}
             </button>
           </div>
         </div>
       </div>
     )}

     {/* مربع حوار إضافة حساب */}
     {isAccountModalOpen && (
       <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
         <div className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl p-8 m-4">
           <h2 className="text-2xl font-bold mb-6 flex items-center">
             <BankIcon className="text-blue-600 ml-2" size={24} />
             إضافة حساب جديد
           </h2>
           
           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
             {/* اسم الحساب */}
             <div className="mb-4">
               <label className="block mb-2 text-sm font-medium text-gray-700">اسم الحساب</label>
               <input
                 type="text"
                 value={newAccount.name}
                 onChange={(e) => setNewAccount({...newAccount, name: e.target.value})}
                 className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                 placeholder="أدخل اسم الحساب"
               />
             </div>
             
             {/* رقم الحساب */}
             <div className="mb-4">
               <label className="block mb-2 text-sm font-medium text-gray-700">رقم الحساب</label>
               <input
                 type="text"
                 value={newAccount.accountNumber}
                 onChange={(e) => setNewAccount({...newAccount, accountNumber: e.target.value})}
                 className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                 placeholder="أدخل رقم الحساب"
               />
             </div>
             
             {/* التصنيف */}
             <div className="mb-4">
               <label className="block mb-2 text-sm font-medium text-gray-700">التصنيف</label>
               <select
                 value={newAccount.categoryId || ''}
                 onChange={(e) => setNewAccount({...newAccount, categoryId: e.target.value ? parseInt(e.target.value) : null})}
                 className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
               >
                 <option value="">بدون تصنيف</option>
                 {categories.map(category => (
                   <option key={category.id} value={category.id}>
                     {category.name}
                   </option>
                 ))}
               </select>
             </div>
             
             {/* الرصيد الافتتاحي */}
             <div className="mb-4">
               <label className="block mb-2 text-sm font-medium text-gray-700">
                 الرصيد الافتتاحي
               </label>
               <div className="relative">
                 <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                   <DollarSign size={16} className="text-gray-400" />
                 </div>
                 <input
                   type="text"
                   inputMode="decimal"
                   value={newAccount.initialBalance}
                   onChange={(e) => {
                     // فلترة الإدخال للسماح فقط بالأرقام والنقطة العشرية
                     const value = e.target.value;
                     // التعبير النمطي يسمح بأرقام ونقطة عشرية واحدة فقط
                     if (value === '' || /^\d*\.?\d*$/.test(value)) {
                       setNewAccount({...newAccount, initialBalance: value});
                     }
                   }}
                   className="w-full pl-3 pr-10 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                   placeholder="0.00"
                   dir="ltr"
                 />
               </div>
             </div>
           </div>
           
           {/* تفاصيل إضافية */}
           <div className="mb-4">
             <label className="block mb-2 text-sm font-medium text-gray-700">تفاصيل إضافية (اختياري)</label>
             <textarea
               value={newAccount.additionalDetails}
               onChange={(e) => setNewAccount({...newAccount, additionalDetails: e.target.value})}
               className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
               placeholder="أدخل أي تفاصيل إضافية"
               rows="3"
             />
           </div>

           {/* أزرار الإجراءات */}
           <div className="flex gap-3 justify-end mt-6">
             <button
               onClick={resetAccountForm}
               className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition"
             >
               إلغاء
             </button>
             <button
               onClick={addAccount}
               disabled={loading || !newAccount.name || !newAccount.accountNumber}
               className={`px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition flex items-center gap-2 ${(loading || !newAccount.name || !newAccount.accountNumber) ? 'opacity-50 cursor-not-allowed' : ''}`}
             >
               {loading ? (
                 <>
                   <div className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin ml-1"></div>
                   <span>جاري الحفظ...</span>
                 </>
               ) : (
                 <>
                   <Save size={16} />
                   <span>إضافة</span>
                 </>
               )}
             </button>
           </div>
         </div>
       </div>
     )}

  {/* عرض تفاصيل الحساب والمعاملات */}
{viewingAccount && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white w-full max-w-5xl rounded-2xl shadow-2xl m-4 overflow-hidden flex flex-col max-h-[90vh]">
      <div className="bg-gradient-to-r from-blue-600 to-indigo-700 py-4 px-6">
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-bold text-white flex items-center">
            <BankIcon className="ml-2" size={24} />
            تفاصيل الحساب: {viewingAccount.name}
          </h2>
          <button
            onClick={closeAccountDetails}
            className="text-white hover:text-gray-200"
          >
            <X size={24} />
          </button>
        </div>
      </div>
      
      <div className="p-6 overflow-auto">
        {/* معلومات الحساب */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
            <h3 className="text-sm font-medium text-gray-500 mb-1">اسم الحساب</h3>
            <p className="text-lg font-semibold">{viewingAccount.name}</p>
          </div>
          <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
            <h3 className="text-sm font-medium text-gray-500 mb-1">رقم الحساب</h3>
            <p className="text-lg font-semibold">{viewingAccount.accountNumber}</p>
          </div>
          <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
            <h3 className="text-sm font-medium text-gray-500 mb-1">التصنيف</h3>
            <p className="text-lg font-semibold">{getCategoryName(viewingAccount.categoryId)}</p>
          </div>
        </div>
        
        {/* الرصيد وإحصائيات الحساب */}
        <div className="bg-gradient-to-r from-blue-500 to-indigo-600 rounded-lg p-6 text-white mb-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <h3 className="text-sm font-medium text-blue-100 mb-1">الرصيد الحالي</h3>
              <p className="text-2xl font-bold">{formatBalance(viewingAccount.balance)}</p>
            </div>
            <div>
              <h3 className="text-sm font-medium text-blue-100 mb-1">إجمالي الإيداعات</h3>
              <p className="text-2xl font-bold">{formatBalance(totalDeposits)}</p>
              <p className="text-xs text-blue-200">{accountTransactions.filter(t => t.type.toLowerCase() === 'deposit' || t.type.toLowerCase() === 'إيداع').length} معاملة</p>
            </div>
            <div>
              <h3 className="text-sm font-medium text-blue-100 mb-1">إجمالي السحوبات</h3>
              <p className="text-2xl font-bold">{formatBalance(totalWithdrawals)}</p>
              <p className="text-xs text-blue-200">{accountTransactions.filter(t => t.type.toLowerCase() === 'withdrawal' || t.type.toLowerCase() === 'سحب').length} معاملة</p>
            </div>
          </div>
        </div>
        
        {/* تفاصيل إضافية */}
        {viewingAccount.additionalDetails && (
          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6">
            <h3 className="text-sm font-medium text-gray-500 mb-2">تفاصيل إضافية</h3>
            <p className="text-sm text-gray-700">{viewingAccount.additionalDetails}</p>
          </div>
        )}
        
        {/* سجل المعاملات */}
     <div>
  <div className="flex justify-between items-center mb-4">
    <h3 className="text-lg font-medium text-gray-900 flex items-center">
      <Activity className="ml-2 text-blue-600" size={20} />
      سجل المعاملات
    </h3>
    <div className="flex items-center gap-4">
      {/* زر الطباعة السريعة */}
      <button
        onClick={printAccountTransactions}
        className="text-gray-600 hover:text-gray-900 flex items-center gap-1 px-3 py-1 border border-gray-200 rounded-md hover:bg-gray-50"
        title="طباعة سريعة لمعاملات الحساب"
        disabled={accountTransactions.length === 0}
      >
        <Printer className="h-4 w-4" />
        <span>طباعة سريعة</span>
      </button>
      
      {/* خيارات عدد المعاملات في الصفحة */}
      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-600">عرض:</span>
        {[15, 25, 50].map((limit) => (
          <button
            key={limit}
            onClick={() => handleAccountTransactionsPerPageChange(limit)}
            className={`px-2 py-1 text-sm rounded transition-colors ${
              accountTransactionsPerPage === limit
                ? 'bg-blue-600 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            {limit}
          </button>
        ))}
      </div>
      
      <button
        onClick={() => fetchAccountTransactions(viewingAccount.id)}
        className="text-blue-600 hover:text-blue-800 flex items-center gap-1 px-3 py-1 border border-blue-200 rounded-md hover:bg-blue-50"
      >
        <RefreshCw className={`h-4 w-4 ${isTransactionsLoading ? 'animate-spin' : ''}`} />
        <span>تحديث</span>
              </button>
            </div>
          </div>
          
          {isTransactionsLoading ? (
            <div className="text-center py-8">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto mb-2"></div>
              <p className="text-gray-500">جاري تحميل المعاملات...</p>
            </div>
          ) : accountTransactions.length === 0 ? (
            <div className="text-center py-10 border-2 border-dashed border-gray-300 rounded-lg">
              <Clipboard className="mx-auto h-10 w-10 text-gray-400 mb-3" />
              <h3 className="text-lg font-medium text-gray-900 mb-1">لا توجد معاملات</h3>
              <p className="text-gray-500">لم يتم تسجيل أي معاملات لهذا الحساب بعد</p>
            </div>
          ) : (
            <div className="overflow-x-auto border rounded-lg">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                      التاريخ
                    </th>
                    <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                      نوع المعاملة
                    </th>
                    <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                      المبلغ
                    </th>
                    <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                      الرصيد
                    </th>
                    <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                      التفاصيل
                    </th>
                    <th scope="col" className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                      الإجراءات
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {accountTransactions.map((transaction, index) => (
                    <tr key={transaction.id || index} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900">
                          {formatDate(transaction.date)}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                          transaction.type.toLowerCase() === 'deposit' || transaction.type.toLowerCase() === 'إيداع' || transaction.type.toLowerCase() === 'adjustment' ? 
                          'bg-green-100 text-green-800' : 
                          'bg-red-100 text-red-800'
                        }`}>
                          {transaction.type.toLowerCase() === 'deposit' || transaction.type.toLowerCase() === 'إيداع' ? 'إيداع' : 
                          transaction.type.toLowerCase() === 'adjustment' ? 'تعديل' : 'سحب'}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`text-sm font-medium ${
                          transaction.type.toLowerCase() === 'deposit' || transaction.type.toLowerCase() === 'إيداع' ? 'text-green-600' : 'text-red-600'
                        }`}>
                          {formatBalance(transaction.amount)}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className="text-sm text-gray-900">
                          {formatBalance(transaction.balance)}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <div className="text-sm font-medium text-gray-900 max-w-xs">
                          {getTransactionClientName(transaction) && (
                            <div className="mb-2 bg-emerald-50 p-2 rounded-md border-r-3 border-emerald-500 text-emerald-900 font-black">
                              العميل: {getTransactionClientName(transaction)}
                            </div>
                          )}
                          {/* عرض تفاصيل معاملة الشركة إذا كانت موجودة */}
                          {transaction.companyDetails ? (
                            <div className="bg-gray-50 p-2 rounded-md border-r-3 border-blue-400">
                              {/* التصنيف والوصف */}
                              <span className={`font-bold ${
                                transaction.companyDetails.categoryType === 'income' 
                                  ? 'text-green-700' 
                                  : 'text-blue-700'
                              }`}>
                                {transaction.companyDetails.categoryName}
                              </span>
                              
                              {(transaction.companyDetails.description || transaction.companyDetails.notes) && (
                                <>
                                  <span className="text-gray-600 font-bold mx-1">:</span>
                                  <span className="text-gray-800">
                                    {transaction.companyDetails.description || transaction.companyDetails.notes}
                                  </span>
                                </>
                              )}
                            </div>
                          ) : (
                            // عرض ملاحظات البنك العادية
                            transaction.notes ? (
                              <div className="bg-blue-50 p-2 rounded-md border-r-3 border-blue-400">
                                <span className="text-gray-800">{transaction.notes}</span>
                              </div>
                            ) : (
                              <span className="text-gray-400">-</span>
                            )
                          )}
                        </div>
                      </td>
                      <td className="px-6 py-4 text-center">
                        <div className="flex justify-center space-x-2 rtl:space-x-reverse">
                          {canDo('حذف المعاملة') && (
                          <button
                            onClick={() => deleteTransaction(transaction.id)}
                            className="text-red-600 hover:text-red-800 transition-colors p-1.5 rounded-full hover:bg-red-50"
                            title="حذف المعاملة"
                          >
                            <Trash2 size={16} />
                          </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* نظام Pagination لمعاملات الحساب */}
              {accountTransactionsPagination.totalPages > 1 && (
                <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
                  <div className="flex items-center justify-between mb-3">
                    <div className="text-sm text-gray-600">
                      صفحة {accountTransactionsPagination.currentPage} من {accountTransactionsPagination.totalPages}
                    </div>
                    <div className="text-xs text-gray-500">
                      عرض {accountTransactions.length} من أصل {accountTransactionsPagination.totalTransactions} معاملة
                    </div>
                  </div>
                  
                  <div className="flex items-center justify-center gap-2">
                    {/* الصفحة الأولى */}
                    <button
                      onClick={() => fetchAccountTransactions(viewingAccount.id, 1, false)}
                      disabled={accountTransactionsPagination.currentPage === 1 || isTransactionsLoading}
                      className="px-3 py-2 rounded border border-gray-300 hover:bg-gray-100 disabled:opacity-50 text-sm"
                      title="الصفحة الأولى"
                    >
                      ««
                    </button>
                    
                    {/* الصفحة السابقة */}
                    <button
                      onClick={() => fetchAccountTransactions(viewingAccount.id, accountTransactionsPagination.currentPage - 1, false)}
                      disabled={!accountTransactionsPagination.hasPrevPage || isTransactionsLoading}
                      className="px-3 py-2 rounded border border-gray-300 hover:bg-gray-100 disabled:opacity-50 text-sm flex items-center gap-1"
                    >
                      <ChevronRight size={16} />
                      السابق
                    </button>
                    
                    {/* أرقام الصفحات */}
                    <div className="flex gap-1">
                      {(() => {
                        const current = accountTransactionsPagination.currentPage;
                        const total = accountTransactionsPagination.totalPages;
                        const maxVisible = 5;
                        let start = Math.max(1, current - Math.floor(maxVisible / 2));
                        let end = Math.min(total, start + maxVisible - 1);
                        
                        if (end - start + 1 < maxVisible) {
                          start = Math.max(1, end - maxVisible + 1);
                        }
                        
                        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
                      })().map(page => (
                        <button
                          key={page}
                          onClick={() => fetchAccountTransactions(viewingAccount.id, page, false)}
                          disabled={isTransactionsLoading}
                          className={`px-3 py-2 rounded text-sm transition-colors ${
                            page === accountTransactionsPagination.currentPage
                              ? 'bg-blue-600 text-white border border-blue-600'
                              : 'border border-gray-300 hover:bg-gray-100 disabled:opacity-50'
                          }`}
                        >
                          {page}
                        </button>
                      ))}
                    </div>
                    
                    {/* الصفحة التالية */}
                    <button
                      onClick={() => fetchAccountTransactions(viewingAccount.id, accountTransactionsPagination.currentPage + 1, false)}
                      disabled={!accountTransactionsPagination.hasNextPage || isTransactionsLoading}
                      className="px-3 py-2 rounded border border-gray-300 hover:bg-gray-100 disabled:opacity-50 text-sm flex items-center gap-1"
                    >
                      التالي
                      <ChevronLeft size={16} />
                    </button>
                    
                    {/* الصفحة الأخيرة */}
                    <button
                      onClick={() => fetchAccountTransactions(viewingAccount.id, accountTransactionsPagination.totalPages, false)}
                      disabled={accountTransactionsPagination.currentPage === accountTransactionsPagination.totalPages || isTransactionsLoading}
                      className="px-3 py-2 rounded border border-gray-300 hover:bg-gray-100 disabled:opacity-50 text-sm"
                      title="الصفحة الأخيرة"
                    >
                      »»
                    </button>
                  </div>

                  {/* معلومات إضافية عن العرض */}
                  <div className="mt-3 text-center text-xs text-gray-500 border-t pt-2">
                    يتم عرض {accountTransactionsPerPage} معاملة في كل صفحة • 
                    إجمالي الصفحات: {accountTransactionsPagination.totalPages}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      
      <div className="bg-gray-50 px-6 py-3 flex justify-between border-t">
        <button
          onClick={() => openAccountExportModal(viewingAccount)}
          className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center gap-2"
        >
          <FileSpreadsheet size={18} />
          تصدير تقرير الحساب
        </button>
        <button
          onClick={closeAccountDetails}
          className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition"
        >
          إغلاق
        </button>
      </div>
    </div>
  </div>
)}

     {/* نافذة الأمان والحماية الجديدة */}
     {securityModal.open && (
       <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-50 p-4">
         <div className="bg-white rounded-lg shadow-2xl max-w-md w-full">
           {/* Header */}
           <div className={`p-6 rounded-t-lg ${
             securityModal.type === 'danger' 
               ? 'bg-gradient-to-r from-red-600 to-red-700' 
               : 'bg-gradient-to-r from-orange-600 to-orange-700'
           }`}>
             <div className="flex items-center text-white">
               <div className="flex-shrink-0">
                 {securityModal.type === 'danger' ? (
                   <div className="w-12 h-12 bg-red-800 rounded-full flex items-center justify-center">
                     <AlertCircle className="w-6 h-6" />
                   </div>
                 ) : (
                   <div className="w-12 h-12 bg-orange-800 rounded-full flex items-center justify-center">
                     <AlertCircle className="w-6 h-6" />
                   </div>
                 )}
               </div>
               <div className="mr-4">
                 <h3 className="text-lg font-bold">
                   {securityModal.type === 'danger' ? '⚠️ تحذير أمني خطير' : '🔒 تأكيد أمني مطلوب'}
                 </h3>
                 <p className="text-sm opacity-90">
                   {securityModal.type === 'danger' 
                     ? 'عملية خطيرة قد تؤدي لفقدان البيانات' 
                     : 'عملية حساسة تحتاج تأكيد'}
                 </p>
               </div>
             </div>
           </div>

           {/* Body */}
           <div className="p-6">
             {securityModal.step === 1 && (
               <div className="text-center">
                 <div className={`w-20 h-20 mx-auto mb-4 rounded-full flex items-center justify-center ${
                   securityModal.type === 'danger' ? 'bg-red-100' : 'bg-orange-100'
                 }`}>
                   <div className={`text-3xl font-bold ${
                     securityModal.type === 'danger' ? 'text-red-600' : 'text-orange-600'
                   }`}>
                     {securityModal.countdown}
                   </div>
                 </div>
                 
                 <h4 className="text-lg font-medium text-gray-900 mb-3">
                   أنت على وشك تنفيذ:
                 </h4>
                 
                 <div className={`p-4 rounded-lg mb-4 ${
                   securityModal.type === 'danger' 
                     ? 'bg-red-50 border border-red-200' 
                     : 'bg-orange-50 border border-orange-200'
                 }`}>
                   <p className={`font-medium ${
                     securityModal.type === 'danger' ? 'text-red-800' : 'text-orange-800'
                   }`}>
                     {securityModal.confirmText}
                   </p>
                 </div>

                 {securityModal.type === 'danger' && (
                   <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-4">
                     <div className="flex items-start">
                       <AlertCircle className="w-5 h-5 text-yellow-600 mt-0.5 ml-2" />
                       <div className="text-sm text-yellow-800">
                         <p className="font-medium mb-1">⚠️ تحذيرات هامة:</p>
                         <ul className="list-disc list-inside space-y-1 text-xs">
                           <li>هذه العملية لا يمكن التراجع عنها</li>
                           <li>قد تفقد بيانات مهمة نهائياً</li>
                           <li>تأكد من وجود نسخة احتياطية حديثة</li>
                           <li>سيتم حذف جميع البيانات المرتبطة</li>
                         </ul>
                       </div>
                     </div>
                   </div>
                 )}

                 <p className="text-sm text-gray-600 mb-4">
                   {securityModal.countdown > 0 
                     ? `انتظر ${securityModal.countdown} ثانية قبل المتابعة...`
                     : 'يمكنك الآن المتابعة للخطوة التالية'
                   }
                 </p>

                 <div className="flex space-x-3 space-x-reverse">
                   <button
                     onClick={nextSecurityStep}
                     disabled={securityModal.countdown > 0}
                     className={`flex-1 px-4 py-2 rounded-lg font-medium transition-all ${
                       securityModal.countdown > 0
                         ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                         : securityModal.type === 'danger'
                           ? 'bg-red-600 hover:bg-red-700 text-white'
                           : 'bg-orange-600 hover:bg-orange-700 text-white'
                     }`}
                   >
                     متابعة للتأكيد النهائي
                   </button>
                   <button
                     onClick={closeSecurityModal}
                     className="flex-1 px-4 py-2 bg-gray-300 hover:bg-gray-400 text-gray-700 rounded-lg font-medium"
                   >
                     إلغاء العملية
                   </button>
                 </div>
               </div>
             )}

             {securityModal.step === 2 && (
               <div>
                 <div className="text-center mb-6">
                   <div className={`w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center ${
                     securityModal.type === 'danger' ? 'bg-red-100' : 'bg-orange-100'
                   }`}>
                     <Shield className={`w-8 h-8 ${
                       securityModal.type === 'danger' ? 'text-red-600' : 'text-orange-600'
                     }`} />
                   </div>
                   
                   <h4 className="text-lg font-medium text-gray-900 mb-2">
                     التأكيد النهائي مطلوب
                   </h4>
                   
                   <p className="text-sm text-gray-600 mb-4">
                     اكتب النص التالي بالضبط للتأكيد:
                   </p>
                   
                   <div className={`p-3 rounded-lg mb-4 font-mono text-sm ${
                     securityModal.type === 'danger' 
                       ? 'bg-red-50 border border-red-200 text-red-800' 
                       : 'bg-orange-50 border border-orange-200 text-orange-800'
                   }`}>
                     {securityModal.confirmText}
                   </div>
                 </div>

                 <div className="mb-6">
                   <input
                     type="text"
                     value={securityModal.userInput}
                     onChange={(e) => setSecurityModal(prev => ({ ...prev, userInput: e.target.value }))}
                     placeholder="اكتب النص هنا للتأكيد..."
                     className={`w-full px-4 py-3 border-2 rounded-lg focus:outline-none font-mono text-sm ${
                       isConfirmTextValid()
                         ? 'border-green-500 bg-green-50 text-green-800'
                         : 'border-gray-300 focus:border-blue-500'
                     }`}
                     autoFocus
                   />
                   
                   {securityModal.userInput && !isConfirmTextValid() && (
                     <p className="text-red-600 text-xs mt-2 flex items-center">
                       <AlertCircle className="w-4 h-4 ml-1" />
                       النص غير مطابق - يجب الكتابة بالضبط كما هو مكتوب أعلاه
                     </p>
                   )}
                   
                   {isConfirmTextValid() && (
                     <p className="text-green-600 text-xs mt-2 flex items-center">
                       <Check className="w-4 h-4 ml-1" />
                       النص مطابق - يمكن المتابعة الآن
                     </p>
                   )}
                 </div>

                 <div className="flex space-x-3 space-x-reverse">
                   <button
                     onClick={nextSecurityStep}
                     disabled={!isConfirmTextValid()}
                     className={`flex-1 px-4 py-3 rounded-lg font-medium transition-all ${
                       isConfirmTextValid()
                         ? securityModal.type === 'danger'
                           ? 'bg-red-600 hover:bg-red-700 text-white'
                           : 'bg-orange-600 hover:bg-orange-700 text-white'
                         : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                     }`}
                   >
                     {securityModal.type === 'danger' ? '🔥 تنفيذ العملية الخطيرة' : '✅ تأكيد وتنفيذ'}
                   </button>
                   <button
                     onClick={closeSecurityModal}
                     className="flex-1 px-4 py-3 bg-gray-300 hover:bg-gray-400 text-gray-700 rounded-lg font-medium"
                   >
                     إلغاء العملية
                   </button>
                 </div>
               </div>
             )}
           </div>
         </div>
       </div>
     )}


     {/* نافذة التصدير العام */}
{isExportModalOpen && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white w-full max-w-2xl rounded-xl shadow-2xl p-6 m-4 max-h-[90vh] overflow-y-auto">
      <h2 className="text-2xl font-bold mb-6 flex items-center">
        <Settings className="text-blue-600 ml-2" />
        تصدير التقرير العام للخزينة
      </h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* نوع التصدير */}
        <div>
          <h3 className="text-lg font-medium mb-3">نوع التصدير</h3>
          <div className="space-y-2">
            <label className="flex items-center">
              <input
                type="radio"
                value="pdf"
                checked={exportOptions.format === 'pdf'}
                onChange={(e) => setExportOptions({...exportOptions, format: e.target.value})}
                className="ml-2"
              />
              <FileText size={18} className="ml-2 text-red-600" />
              ملف PDF - مُوصى به
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                value="excel"
                checked={exportOptions.format === 'excel'}
                onChange={(e) => setExportOptions({...exportOptions, format: e.target.value})}
                className="ml-2"
              />
              <FileSpreadsheet size={18} className="ml-2 text-green-600" />
              ملف Excel/CSV
            </label>
          </div>
        </div>
        
        {/* خيارات التضمين */}
        <div>
          <h3 className="text-lg font-medium mb-3">محتويات التقرير</h3>
          <div className="space-y-2">
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={exportOptions.includeBalance}
                onChange={(e) => setExportOptions({...exportOptions, includeBalance: e.target.checked})}
                className="ml-2"
              />
              تضمين أرصدة الحسابات
            </label>
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={exportOptions.includeSummary}
                onChange={(e) => setExportOptions({...exportOptions, includeSummary: e.target.checked})}
                className="ml-2"
              />
              تضمين الملخص الإجمالي
            </label>
          </div>
        </div>
      </div>
      
      {/* معاينة التقرير */}
      <div className="mt-6 p-4 bg-gray-50 rounded-lg">
        <h4 className="font-medium text-gray-700 mb-2">معاينة التقرير:</h4>
        <div className="text-sm text-gray-600">
          <p>عدد الحسابات: {accounts.length}</p>
          <p>الرصيد الإجمالي: {formatBalance(totalBalance)}</p>
          <p>نوع التصدير: {exportOptions.format === 'pdf' ? 'ملف PDF' : 'ملف Excel/CSV'}</p>
        </div>
      </div>
      
      <div className="flex justify-end gap-3 mt-6">
        <button
          onClick={() => setIsExportModalOpen(false)}
          className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
        >
          إلغاء
        </button>
        <button
          onClick={executeGeneralExport}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2"
        >
          <Download size={18} />
          تصدير التقرير
        </button>
      </div>
    </div>
  </div>
)}

{/* نافذة التصدير الخاص بحساب واحد */}
{isAccountExportModalOpen && exportingAccount && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white w-full max-w-3xl rounded-xl shadow-2xl p-6 m-4 max-h-[90vh] overflow-y-auto">
      <h2 className="text-2xl font-bold mb-6 flex items-center">
        <BankIcon className="text-blue-600 ml-2" />
        تصدير تقرير الحساب: {exportingAccount.name}
      </h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* نوع التصدير */}
        <div>
          <h3 className="text-lg font-medium mb-3">نوع التصدير</h3>
          <div className="space-y-2">
            <label className="flex items-center">
              <input
                type="radio"
                value="pdf"
                checked={accountExportOptions.format === 'pdf'}
                onChange={(e) => setAccountExportOptions({...accountExportOptions, format: e.target.value})}
                className="ml-2"
              />
              <FileText size={18} className="ml-2 text-red-600" />
              ملف PDF - مُوصى به
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                value="excel"
                checked={accountExportOptions.format === 'excel'}
                onChange={(e) => setAccountExportOptions({...accountExportOptions, format: e.target.value})}
                className="ml-2"
              />
              <FileSpreadsheet size={18} className="ml-2 text-green-600" />
              ملف Excel/CSV
            </label>
          </div>
        </div>
        
         {/* نطاق البيانات - خيار جديد */}
         <div>
          <h3 className="text-lg font-medium mb-3">نطاق البيانات</h3>
          <div className="space-y-2">
            <label className="flex items-center">
              <input
                type="radio"
                value="current"
                checked={accountExportOptions.dataScope === 'current'}
                onChange={(e) => setAccountExportOptions({...accountExportOptions, dataScope: e.target.value})}
                className="ml-2"
              />
              <Eye size={16} className="ml-1 text-blue-600" />
              البيانات المعروضة حالياً
              <span className="text-xs text-gray-500 mr-1">({accountTransactions.length} معاملة)</span>
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                value="all"
                checked={accountExportOptions.dataScope === 'all'}
                onChange={(e) => setAccountExportOptions({...accountExportOptions, dataScope: e.target.value})}
                className="ml-2"
              />
              <Layers size={16} className="ml-1 text-orange-600" />
              جميع البيانات من قاعدة البيانات
            </label>
          </div>
        </div>

        {/* نطاق البيانات */}
        <div>
          <h3 className="text-lg font-medium mb-3">نطاق المعاملات</h3>
          <div className="space-y-2">
            <label className="flex items-center">
              <input
                type="radio"
                value="all"
                checked={accountExportOptions.dateRange === 'all'}
                onChange={(e) => setAccountExportOptions({...accountExportOptions, dateRange: e.target.value})}
                className="ml-2"
              />
              جميع المعاملات
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                value="custom"
                checked={accountExportOptions.dateRange === 'custom'}
                onChange={(e) => setAccountExportOptions({...accountExportOptions, dateRange: e.target.value})}
                className="ml-2"
              />
              فترة مخصصة
            </label>
          </div>
          
          {/* التاريخ المخصص */}
          {accountExportOptions.dateRange === 'custom' && (
            <div className="mt-3 space-y-2">
              <div>
                <label className="block text-sm text-gray-600 mb-1">من تاريخ</label>
                <input
                  type="date"
                  value={accountExportOptions.customStartDate}
                  onChange={(e) => setAccountExportOptions({...accountExportOptions, customStartDate: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">إلى تاريخ</label>
                <input
                  type="date"
                  value={accountExportOptions.customEndDate}
                  onChange={(e) => setAccountExportOptions({...accountExportOptions, customEndDate: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
          )}
        </div>
        
        {/* فلتر أنواع المعاملات */}
        <div>
          <h3 className="text-lg font-medium mb-3">أنواع المعاملات</h3>
          <div className="space-y-2">
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={accountExportOptions.selectedTypes.includes('deposit')}
                onChange={(e) => {
                  if (e.target.checked) {
                    setAccountExportOptions({
                      ...accountExportOptions,
                      selectedTypes: [...accountExportOptions.selectedTypes, 'deposit']
                    });
                  } else {
                    setAccountExportOptions({
                      ...accountExportOptions,
                      selectedTypes: accountExportOptions.selectedTypes.filter(t => t !== 'deposit')
                    });
                  }
                }}
                className="ml-2"
              />
              <TrendingUp size={16} className="ml-1 text-green-600" />
              الإيداعات
            </label>
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={accountExportOptions.selectedTypes.includes('withdrawal')}
                onChange={(e) => {if (e.target.checked) {
                   setAccountExportOptions({
                     ...accountExportOptions,
                     selectedTypes: [...accountExportOptions.selectedTypes, 'withdrawal']
                   });
                 } else {
                   setAccountExportOptions({
                     ...accountExportOptions,
                     selectedTypes: accountExportOptions.selectedTypes.filter(t => t !== 'withdrawal')
                   });
                 }
               }}
               className="ml-2"
             />
             <TrendingDown size={16} className="ml-1 text-red-600" />
             السحوبات
           </label>
           <label className="flex items-center">
             <input
               type="checkbox"
               checked={accountExportOptions.selectedTypes.includes('adjustment')}
               onChange={(e) => {
                 if (e.target.checked) {
                   setAccountExportOptions({
                     ...accountExportOptions,
                     selectedTypes: [...accountExportOptions.selectedTypes, 'adjustment']
                   });
                 } else {
                   setAccountExportOptions({
                     ...accountExportOptions,
                     selectedTypes: accountExportOptions.selectedTypes.filter(t => t !== 'adjustment')
                   });
                 }
               }}
               className="ml-2"
             />
             <Edit size={16} className="ml-1 text-blue-600" />
             التعديلات
           </label>
         </div>
       </div>
       
       {/* خيارات إضافية */}
       <div>
         <h3 className="text-lg font-medium mb-3">خيارات إضافية</h3>
         <div className="space-y-2">
           <label className="flex items-center">
             <input
               type="checkbox"
               checked={accountExportOptions.includeBalance}
               onChange={(e) => setAccountExportOptions({...accountExportOptions, includeBalance: e.target.checked})}
               className="ml-2"
             />
             تضمين معلومات الرصيد
           </label>
           <label className="flex items-center">
             <input
               type="checkbox"
               checked={accountExportOptions.includeTransactions}
               onChange={(e) => setAccountExportOptions({...accountExportOptions, includeTransactions: e.target.checked})}
               className="ml-2"
             />
             تضمين سجل المعاملات
           </label>
           <label className="flex items-center">
             <input
               type="checkbox"
               checked={accountExportOptions.includeSummary}
               onChange={(e) => setAccountExportOptions({...accountExportOptions, includeSummary: e.target.checked})}
               className="ml-2"
             />
             تضمين الملخص الإحصائي
           </label>
         </div>
       </div>
     </div>
     
     {/* معاينة التقرير */}
     <div className="mt-6 p-4 bg-gray-50 rounded-lg">
       <h4 className="font-medium text-gray-700 mb-2">معاينة تقرير الحساب:</h4>
       <div className="text-sm text-gray-600">
         <p>اسم الحساب: {exportingAccount.name}</p>
         <p>رقم الحساب: {exportingAccount.accountNumber}</p>
         <p>الرصيد الحالي: {formatBalance(exportingAccount.balance)}</p>
         <p>عدد المعاملات: {accountTransactions.length}</p>
         <p>نوع التصدير: {accountExportOptions.format === 'pdf' ? 'ملف PDF' : 'ملف Excel/CSV'}</p>
       </div>
     </div>
     
     <div className="flex justify-end gap-3 mt-6">
       <button
         onClick={() => setIsAccountExportModalOpen(false)}
         className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
       >
         إلغاء
       </button>
       <button
         onClick={executeAccountExport}
         disabled={accountExportOptions.selectedTypes.length === 0}
         className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2 disabled:opacity-50"
       >
         <Download size={18} />
         تصدير تقرير الحساب
       </button>
     </div>
   </div>
 </div>
)}

{/* نافذة التصدير الخاص بسجل المعاملات */}
{isTransactionsExportModalOpen && (
 <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
   <div className="bg-white w-full max-w-4xl rounded-xl shadow-2xl p-6 m-4 max-h-[90vh] overflow-y-auto">
     <h2 className="text-2xl font-bold mb-6 flex items-center">
       <Activity className="text-blue-600 ml-2" />
       تصدير سجل المعاملات الشامل
     </h2>
     
     <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
       {/* نوع التصدير */}
       <div>
         <h3 className="text-lg font-medium mb-3">نوع التصدير</h3>
         <div className="space-y-2">
           <label className="flex items-center">
             <input
               type="radio"
               value="pdf"
               checked={transactionsExportOptions.format === 'pdf'}
               onChange={(e) => setTransactionsExportOptions({...transactionsExportOptions, format: e.target.value})}
               className="ml-2"
             />
             <FileText size={18} className="ml-2 text-red-600" />
             ملف PDF - مُوصى به
           </label>
           <label className="flex items-center">
             <input
               type="radio"
               value="excel"
               checked={transactionsExportOptions.format === 'excel'}
               onChange={(e) => setTransactionsExportOptions({...transactionsExportOptions, format: e.target.value})}
               className="ml-2"
             />
             <FileSpreadsheet size={18} className="ml-2 text-green-600" />
             ملف Excel/CSV
           </label>
         </div>
       </div>
       
        {/* نطاق البيانات - خيار جديد */}
        <div>
          <h3 className="text-lg font-medium mb-3">نطاق البيانات</h3>
          <div className="space-y-2">
            <label className="flex items-center">
              <input
                type="radio"
                value="current"
                checked={transactionsExportOptions.dataScope === 'current'}
                onChange={(e) => setTransactionsExportOptions({...transactionsExportOptions, dataScope: e.target.value})}
                className="ml-2"
              />
              <Eye size={16} className="ml-1 text-blue-600" />
              البيانات المعروضة حالياً
              <span className="text-xs text-gray-500 mr-1">({allTransactions.length} معاملة)</span>
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                value="all"
                checked={transactionsExportOptions.dataScope === 'all'}
                onChange={(e) => setTransactionsExportOptions({...transactionsExportOptions, dataScope: e.target.value})}
                className="ml-2"
              />
              <Layers size={16} className="ml-1 text-orange-600" />
              جميع البيانات من قاعدة البيانات
            </label>
          </div>
        </div>

       {/* نطاق البيانات */}
       <div>
         <h3 className="text-lg font-medium mb-3">نطاق البيانات</h3>
         <div className="space-y-2">
           <label className="flex items-center">
             <input
               type="radio"
               value="all"
               checked={transactionsExportOptions.dateRange === 'all'}
               onChange={(e) => setTransactionsExportOptions({...transactionsExportOptions, dateRange: e.target.value})}
               className="ml-2"
             />
             جميع المعاملات
           </label>
           <label className="flex items-center">
             <input
               type="radio"
               value="custom"
               checked={transactionsExportOptions.dateRange === 'custom'}
               onChange={(e) => setTransactionsExportOptions({...transactionsExportOptions, dateRange: e.target.value})}
               className="ml-2"
             />
             فترة مخصصة
           </label>
         </div>
         
         {/* التاريخ المخصص */}
         {transactionsExportOptions.dateRange === 'custom' && (
           <div className="mt-3 space-y-2">
             <div>
               <label className="block text-sm text-gray-600 mb-1">من تاريخ</label>
               <input
                 type="date"
                 value={transactionsExportOptions.customStartDate}
                 onChange={(e) => setTransactionsExportOptions({...transactionsExportOptions, customStartDate: e.target.value})}
                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
               />
             </div>
             <div>
               <label className="block text-sm text-gray-600 mb-1">إلى تاريخ</label>
               <input
                 type="date"
                 value={transactionsExportOptions.customEndDate}
                 onChange={(e) => setTransactionsExportOptions({...transactionsExportOptions, customEndDate: e.target.value})}
                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
               />
             </div>
           </div>
         )}
       </div>
       
       {/* فلتر أنواع المعاملات */}
       <div>
         <h3 className="text-lg font-medium mb-3">أنواع المعاملات</h3>
         <div className="space-y-2">
           <label className="flex items-center">
             <input
               type="checkbox"
               checked={transactionsExportOptions.selectedTypes.includes('deposit')}
               onChange={(e) => {
                 if (e.target.checked) {
                   setTransactionsExportOptions({
                     ...transactionsExportOptions,
                     selectedTypes: [...transactionsExportOptions.selectedTypes, 'deposit']
                   });
                 } else {
                   setTransactionsExportOptions({
                     ...transactionsExportOptions,
                     selectedTypes: transactionsExportOptions.selectedTypes.filter(t => t !== 'deposit')
                   });
                 }
               }}
               className="ml-2"
             />
             <TrendingUp size={16} className="ml-1 text-green-600" />
             الإيداعات
           </label>
           <label className="flex items-center">
             <input
               type="checkbox"
               checked={transactionsExportOptions.selectedTypes.includes('withdrawal')}
               onChange={(e) => {
                 if (e.target.checked) {
                   setTransactionsExportOptions({
                     ...transactionsExportOptions,
                     selectedTypes: [...transactionsExportOptions.selectedTypes, 'withdrawal']
                   });
                 } else {
                   setTransactionsExportOptions({
                     ...transactionsExportOptions,
                     selectedTypes: transactionsExportOptions.selectedTypes.filter(t => t !== 'withdrawal')
                   });
                 }
               }}
               className="ml-2"
             />
             <TrendingDown size={16} className="ml-1 text-red-600" />
             السحوبات
           </label>
           <label className="flex items-center">
             <input
               type="checkbox"
               checked={transactionsExportOptions.selectedTypes.includes('adjustment')}
               onChange={(e) => {
                 if (e.target.checked) {
                   setTransactionsExportOptions({
                     ...transactionsExportOptions,
                     selectedTypes: [...transactionsExportOptions.selectedTypes, 'adjustment']
                   });
                 } else {
                   setTransactionsExportOptions({
                     ...transactionsExportOptions,
                     selectedTypes: transactionsExportOptions.selectedTypes.filter(t => t !== 'adjustment')
                   });
                 }
               }}
               className="ml-2"
             />
             <Edit size={16} className="ml-1 text-blue-600" />
             التعديلات
           </label>
         </div>
       </div>
       
       {/* فلتر الحسابات */}
       <div>
         <h3 className="text-lg font-medium mb-3">فلتر الحسابات</h3>
         <div className="max-h-40 overflow-y-auto space-y-2">
           <label className="flex items-center">
             <input
               type="checkbox"
               checked={transactionsExportOptions.selectedAccounts.length === 0}
               onChange={(e) => {
                 if (e.target.checked) {
                   setTransactionsExportOptions({
                     ...transactionsExportOptions,
                     selectedAccounts: []
                   });
                 }
               }}
               className="ml-2"
             />
             <span className="font-medium">جميع الحسابات</span>
           </label>
           {accounts.map(account => (
             <label key={account.id} className="flex items-center">
               <input
                 type="checkbox"
                 checked={transactionsExportOptions.selectedAccounts.includes(account.name)}
                 onChange={(e) => {
                   if (e.target.checked) {
                     setTransactionsExportOptions({
                       ...transactionsExportOptions,
                       selectedAccounts: [...transactionsExportOptions.selectedAccounts, account.name]
                     });
                   } else {
                     setTransactionsExportOptions({
                       ...transactionsExportOptions,
                       selectedAccounts: transactionsExportOptions.selectedAccounts.filter(name => name !== account.name)
                     });
                   }
                 }}
                 className="ml-2"
               />
               <span className="text-sm">{account.name}</span>
             </label>
           ))}
         </div>
       </div>
       
       {/* خيارات إضافية */}
       <div>
         <h3 className="text-lg font-medium mb-3">خيارات إضافية</h3>
         <div className="space-y-2">
           <label className="flex items-center">
             <input
               type="checkbox"
               checked={transactionsExportOptions.includeBalance}
               onChange={(e) => setTransactionsExportOptions({...transactionsExportOptions, includeBalance: e.target.checked})}
               className="ml-2"
             />
             تضمين أرصدة الحسابات
           </label>
           <label className="flex items-center">
             <input
               type="checkbox"
               checked={transactionsExportOptions.includeSummary}
               onChange={(e) => setTransactionsExportOptions({...transactionsExportOptions, includeSummary: e.target.checked})}
               className="ml-2"
             />
             تضمين الملخص الإحصائي
           </label>
         </div>
       </div>
     </div>
     
     {/* معاينة التقرير */}
     <div className="mt-6 p-4 bg-gray-50 rounded-lg">
       <h4 className="font-medium text-gray-700 mb-2">معاينة سجل المعاملات:</h4>
       <div className="text-sm text-gray-600">
         <p>إجمالي المعاملات: {allTransactions.length}</p>
         <p>الحسابات المحددة: {
           transactionsExportOptions.selectedAccounts.length === 0 
             ? 'جميع الحسابات' 
             : `${transactionsExportOptions.selectedAccounts.length} حساب`
         }</p>
         <p>أنواع المعاملات المحددة: {transactionsExportOptions.selectedTypes.length}</p>
         <p>نوع التصدير: {transactionsExportOptions.format === 'pdf' ? 'ملف PDF' : 'ملف Excel/CSV'}</p>
       </div>
     </div>
     
     <div className="flex justify-end gap-3 mt-6">
       <button
         onClick={() => setIsTransactionsExportModalOpen(false)}
         className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
       >
         إلغاء
       </button>
       <button
         onClick={executeTransactionsExport}
         disabled={transactionsExportOptions.selectedTypes.length === 0}
         className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2 disabled:opacity-50"
       >
         <Download size={18} />
         تصدير سجل المعاملات
       </button>
     </div>
   </div>
 </div>
)}
   </div>
 );
};

export default BanksManagement;